var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.91,73.06V311.78H698.63V73.06ZM552.85,299.43H431.49V83.58H552.85Zm132.93,0H564.42V83.58H685.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.19,143.36c.1.1-13.18,13.54-29.66,30s-29.93,29.76-30,29.66,13.18-13.54,29.66-30S635.09,143.26,635.19,143.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.35,108.38c.1.1-13.81,14.18-31.06,31.43S594,171,593.85,170.88s13.81-14.17,31.07-31.44S656.25,108.28,656.35,108.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,182.15c.1.11-13.18,13.55-29.66,30s-29.93,29.76-30,29.66,13.18-13.54,29.66-30S503.87,182.05,504,182.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.13,147.18c.1.1-13.81,14.18-31.06,31.43s-31.34,31.17-31.44,31.06,13.81-14.17,31.07-31.43S525,147.08,525.13,147.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,295.77H179.33a4,4,0,0,1,0,7.94H113.62V456.53l36.82,9.8H63.3c.57,0,37.51-9.8,37.51-9.8V303.71H32.5a4,4,0,1,1,0-7.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.82 267.21 77.96 296.48 62.85 296.48 59.88 267.21 80.82 267.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.09,
    y: 265.07,
    width: 24.99,
    height: 2.14,
    transform: "translate(141.17 532.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.32 261.38 80.82 265.55 60.95 265.55 61.9 261.38 78.32 261.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.86 277.07 78.84 287.51 61.94 287.51 60.88 277.07 79.86 277.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,285.23a4.79,4.79,0,0,1,.78-2.59c.42-.65.93-1.22,1.34-1.78a5.44,5.44,0,0,0,.88-1.65,3.06,3.06,0,0,0,.13-.72.67.67,0,0,1,.12.06,2.62,2.62,0,0,1,1.1,1.72,4.92,4.92,0,0,1-.1,2.09,4.47,4.47,0,0,1-1.09,2.22,3,3,0,0,1-2.64.81A2.4,2.4,0,0,1,68.2,285.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.92,282.93a8.77,8.77,0,0,1,.53-2.74,3,3,0,0,1,2-1.85,2.33,2.33,0,0,1,1.46.07,3.51,3.51,0,0,1-.18.73,5.7,5.7,0,0,1-.89,1.55,22.45,22.45,0,0,0-1.38,1.79,4.87,4.87,0,0,0-.77,2.16c0,.16,0,.31,0,.46a1.51,1.51,0,0,1-.57-.58A2.68,2.68,0,0,1,66.92,282.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.03 267.21 114.17 296.48 99.06 296.48 96.09 267.21 117.03 267.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.3,
    y: 265.07,
    width: 24.99,
    height: 2.14,
    transform: "translate(213.59 532.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.53 261.38 117.03 265.55 97.16 265.55 98.11 261.38 114.53 261.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.07 277.07 115.05 287.51 98.15 287.51 97.09 277.07 116.07 277.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,285.23a4.79,4.79,0,0,1,.78-2.59c.42-.65.93-1.22,1.34-1.78a5.44,5.44,0,0,0,.88-1.65,3.06,3.06,0,0,0,.13-.72.67.67,0,0,1,.12.06,2.62,2.62,0,0,1,1.1,1.72,5.08,5.08,0,0,1-.09,2.09,4.57,4.57,0,0,1-1.1,2.22,3,3,0,0,1-2.64.81A2.4,2.4,0,0,1,104.41,285.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.13,282.93a8.77,8.77,0,0,1,.53-2.74,3,3,0,0,1,2-1.85,2.33,2.33,0,0,1,1.46.07,3.51,3.51,0,0,1-.18.73,5.7,5.7,0,0,1-.89,1.55,22.45,22.45,0,0,0-1.38,1.79,4.87,4.87,0,0,0-.77,2.16c0,.16,0,.31,0,.46a1.51,1.51,0,0,1-.57-.58A2.68,2.68,0,0,1,103.13,282.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.31,
    y: 54.67,
    width: 101.84,
    height: 147.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.21,
    y: 54.67,
    width: 101.84,
    height: 147.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.86,
    y: 70.66,
    width: 76.54,
    height: 115.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,186.3s0-.19,0-.56,0-.93,0-1.64q0-2.19,0-6.35c0-5.54,0-13.62-.07-23.82,0-20.39-.08-49.27-.13-83.27l.26.25-76.53,0h0l.28-.28c0,43.62,0,83.85-.06,115.64l-.22-.22,55.71.12,15.39.05,4,0,1.4,0-1.35,0-4,0-15.34.06-55.85.11h-.22v-.22c0-31.79,0-72-.06-115.64v-.28h.29l76.53,0h.25v.25c-.05,34.07-.09,63-.12,83.44,0,10.18-.06,18.23-.07,23.76,0,2.74,0,4.85,0,6.29,0,.71,0,1.24,0,1.62S137.4,186.3,137.4,186.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.34,54.67a17.78,17.78,0,0,1-1.82,2.64c-1.18,1.58-2.86,3.73-4.78,6.06s-3.7,4.39-5,5.85a17.4,17.4,0,0,1-2.24,2.29A18.79,18.79,0,0,1,138.41,69L143.32,63l4.89-6A18.74,18.74,0,0,1,150.34,54.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.79,185.93a94.59,94.59,0,0,0,13.35,16.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,202.62a14.94,14.94,0,0,1-2.33-2.11,75.93,75.93,0,0,1-5-5.68,72.87,72.87,0,0,1-4.43-6.17,15.15,15.15,0,0,1-1.55-2.73,21.82,21.82,0,0,1,1.88,2.52c1.12,1.57,2.7,3.73,4.54,6s3.59,4.32,4.89,5.76A24.59,24.59,0,0,1,151.14,202.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.19,202.17q6.68-8.22,13.34-16.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.53,185.71a101.14,101.14,0,0,1-6.45,8.41,101.79,101.79,0,0,1-6.89,8,101,101,0,0,1,6.46-8.4A101.92,101.92,0,0,1,61.53,185.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.21,54.67a92.16,92.16,0,0,1,6.47,7.74,89.77,89.77,0,0,1,6,8.09,94.49,94.49,0,0,1-6.47-7.74A89.77,89.77,0,0,1,48.21,54.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.92,
    y: 94.14,
    width: 25.63,
    height: 72.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.6,
    y: 36.66,
    width: 68.65,
    height: 71.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.95,
    y: 36.66,
    width: 68.65,
    height: 71.56,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62,108.24H181.93V36.64h68.69Zm-68.65,0h68.6V36.68H182Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.17,
    y: 46.28,
    width: 50.19,
    height: 52.32,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17,99a8,8,0,0,1-1.23,1.44c-.81.85-1.93,2-3.19,3.23s-2.43,2.36-3.28,3.14A8.4,8.4,0,0,1,182,108a7.64,7.64,0,0,1,1.23-1.43c.8-.85,1.93-2,3.2-3.24s2.42-2.36,3.28-3.15A8,8,0,0,1,191.17,99Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.37,98.82a8.83,8.83,0,0,1,1.44,1.24c.84.8,2,1.93,3.23,3.19s2.35,2.42,3.14,3.28a8,8,0,0,1,1.21,1.45,8,8,0,0,1-1.44-1.23c-.84-.8-2-1.93-3.24-3.2s-2.35-2.43-3.14-3.29A7.29,7.29,0,0,1,241.37,98.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,46.42A8.36,8.36,0,0,1,242.47,45c.8-.85,1.93-2,3.19-3.23s2.42-2.36,3.28-3.14a7.59,7.59,0,0,1,1.45-1.21,8.16,8.16,0,0,1-1.23,1.43c-.81.85-1.93,2-3.2,3.24s-2.43,2.36-3.29,3.15A7.77,7.77,0,0,1,241.23,46.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,46.55a7.94,7.94,0,0,1-1.44-1.24c-.85-.8-2-1.93-3.24-3.19s-2.35-2.42-3.14-3.28a8,8,0,0,1-1.2-1.45,8.62,8.62,0,0,1,1.43,1.23c.85.8,2,1.93,3.24,3.2s2.36,2.43,3.15,3.28A8.58,8.58,0,0,1,191,46.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,98.6s0-.09,0-.25,0-.42,0-.73c0-.66,0-1.6,0-2.83,0-2.48,0-6.08-.05-10.66,0-9.16,0-22.22-.09-37.85l.19.19-50,0h0l.23-.22c0,19.2,0,37.17,0,52.32l-.2-.19,36.25.1,10.18,0,2.69,0h0l-2.65,0-10.14,0-36.37.1H191V98.6c0-15.15,0-33.12,0-52.32v-.22h.23l50,0h.19v.19c0,15.68-.07,28.78-.1,38,0,4.56,0,8.15,0,10.62,0,1.21,0,2.14,0,2.79,0,.3,0,.54,0,.71A1.66,1.66,0,0,1,241.23,98.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48,81.2a12.18,12.18,0,0,0-2-6.57c-1.07-1.67-2.37-3.1-3.41-4.54a13.47,13.47,0,0,1-2.22-4.19,7.69,7.69,0,0,1-.34-1.84l-.3.15a6.74,6.74,0,0,0-2.8,4.39,12.49,12.49,0,0,0,.24,5.3,11.53,11.53,0,0,0,2.79,5.64,7.74,7.74,0,0,0,6.71,2.08A7,7,0,0,0,221.48,81.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.77,75a22.12,22.12,0,0,0-1.36-7c-.94-2.18-2.75-4.24-5.08-4.71a6,6,0,0,0-3.69.17,7.62,7.62,0,0,0,.45,1.87,14.38,14.38,0,0,0,2.27,3.94c1,1.38,2.37,2.8,3.49,4.55a12.16,12.16,0,0,1,2,5.48c0,.4.06.79.07,1.18a4.08,4.08,0,0,0,1.45-1.47A7,7,0,0,0,224.77,75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.55,
    y: 128.55,
    width: 59.76,
    height: 62.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 128.55,
    width: 59.76,
    height: 62.29,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.27,190.85H218.48V128.53h59.79Zm-59.75,0h59.72V128.56H218.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.53,
    y: 136.92,
    width: 43.69,
    height: 45.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.53,182.77a7,7,0,0,1-1.08,1.25c-.69.74-1.67,1.73-2.77,2.81s-2.11,2-2.86,2.74a6.79,6.79,0,0,1-1.26,1.05,6.67,6.67,0,0,1,1.07-1.25c.7-.74,1.68-1.74,2.79-2.82s2.11-2.05,2.85-2.74A6.67,6.67,0,0,1,226.53,182.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.22,182.65a7.4,7.4,0,0,1,1.26,1.08c.73.7,1.73,1.68,2.81,2.78s2,2.11,2.73,2.85a6.5,6.5,0,0,1,1.05,1.27,7.86,7.86,0,0,1-1.24-1.08c-.74-.69-1.74-1.68-2.82-2.78s-2.06-2.11-2.74-2.86A6.31,6.31,0,0,1,270.22,182.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1,137a7.16,7.16,0,0,1,1.08-1.25c.7-.74,1.68-1.74,2.78-2.82s2.11-2.05,2.85-2.73a7.66,7.66,0,0,1,1.26-1.05,6.67,6.67,0,0,1-1.07,1.25c-.7.73-1.68,1.73-2.78,2.82s-2.12,2.05-2.86,2.73A6.66,6.66,0,0,1,270.1,137Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.41,137.15a7,7,0,0,1-1.25-1.08c-.74-.69-1.73-1.67-2.82-2.77s-2-2.11-2.73-2.86a6.79,6.79,0,0,1-1.05-1.26,6.67,6.67,0,0,1,1.25,1.07c.73.7,1.73,1.68,2.82,2.79s2.05,2.11,2.74,2.86A7,7,0,0,1,226.41,137.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1,182.46s0-.08,0-.22,0-.36,0-.63c0-.58,0-1.4,0-2.46,0-2.16,0-5.3,0-9.29,0-8,0-19.33-.09-32.94l.17.17-43.56,0h0l.2-.19c0,16.72,0,32.35,0,45.54l-.17-.16,31.55.08,8.86,0,2.35,0h.81s-.06,0-.19,0h-.59l-2.31,0-8.82,0-31.66.09h-.16v-.17c0-13.19,0-28.82,0-45.54v-.19h.2l43.56,0h.17v.17c0,13.65-.06,25.05-.08,33.05,0,4,0,7.1-.05,9.25,0,1.05,0,1.86,0,2.42,0,.27,0,.47,0,.62S270.11,182.47,270.1,182.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,167.31a10.65,10.65,0,0,0-1.73-5.72c-.94-1.44-2.06-2.7-3-4a11.68,11.68,0,0,1-1.93-3.65,6.53,6.53,0,0,1-.3-1.6l-.26.14a5.84,5.84,0,0,0-2.44,3.82,10.88,10.88,0,0,0,.21,4.61,10,10,0,0,0,2.43,4.91,6.74,6.74,0,0,0,5.84,1.81A5.93,5.93,0,0,0,252.91,167.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,161.92a19.13,19.13,0,0,0-1.18-6.06,6.68,6.68,0,0,0-4.42-4.1,5.15,5.15,0,0,0-3.21.15,6.46,6.46,0,0,0,.39,1.63,12.36,12.36,0,0,0,2,3.42c.92,1.2,2.06,2.44,3.05,4a10.74,10.74,0,0,1,1.69,4.78c0,.35.05.69.06,1a3.54,3.54,0,0,0,1.27-1.28A6.17,6.17,0,0,0,255.77,161.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477.79,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.28,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.78,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.28,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.77,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.27,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.18,
    y: 365.5,
    width: 16.49,
    height: 98.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 376.68,
    width: 187.98,
    height: 5.3,
    rx: 1.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.78,
    y: 452.51,
    width: 187.98,
    height: 5.3,
    rx: 1.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,456.39c-1.69-1.44-5.46-6-2.55-11.38,1.06-1.95,3.32-2.92,5.37-3.78a22.2,22.2,0,0,0,5.9-3.06c3.2-2.72,4.08-7.24,6.2-10.86,2.44-4.17,7-7.29,11.79-7.07,5.5.25,10.09,4.74,12.17,9.87s2.15,10.81,2.19,16.34c0,3.06-.11,6.51-2.36,8.57-2.07,1.91-5.19,1.93-8,1.84L310,455.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.87,373.73H287.81l14.24,84.92a9.49,9.49,0,0,0,6.75,7.56l.27.07c.24.06.47.14.71.18a9.45,9.45,0,0,0,1.61.19v.08l.38-.06H347a10.29,10.29,0,0,0,1.94-.19,9.54,9.54,0,0,0,8-8.3l6.86-58.51.31-2.33h0l2.71-23.17ZM352,427.89h-8.11l.82-24.64h9.4Zm2.89-24.64h7.77l-2.89,24.64h-7Zm-23.17,52-.5-21.41h11.69l-.72,21.41ZM319,433.81h11.36l.49,21.41H320.7Zm.88,21.41h-9.52c-.9-5.79-2.08-13.3-3.35-21.41h11.21Zm-1.34-27.33-1.91-24.64h13l.57,24.64Zm12.47,0-.57-24.64h13.4l-.82,24.64Zm-.71-30.55-.52-22.82h15l-.76,22.82Zm-.78,0H316.2l-1.77-22.82H329Zm-14.14,0H301.29c-.5-3.15-1-6.14-1.4-8.82-1.47-9.23-2-12.7-2.33-14h16.08Zm.46,5.91,1.92,24.64H306.11c-.39-2.5-.79-5-1.19-7.56-.91-5.81-1.83-11.63-2.69-17.08Zm-10.55,24.64h-7.63l-4.14-24.64h7.88C302.64,410.87,304,419.34,305.32,427.89Zm.92,5.92c1.17,7.4,2.31,14.71,3.36,21.41h-7.33l-3.59-21.41Zm36.69,21.41.71-21.41h7.81l-1.83,21.41Zm1.92-57.88.76-22.82h10.9l-1.95,22.82Zm-48-22.82c.31,1.65,1.75,10.63,3.69,22.82h-7.94l-3.83-22.82Zm59.7,80.7H350.4l1.83-21.41H359Zm6.8-57.88h-8l1.95-22.82H366Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.4,243.63c-7.42-11.34-6.34-27.55,2.52-37.81,2.75-3.18,6.59-5.95,10.78-5.59s7.75,4.05,9.06,8.15.85,8.55.08,12.79c-1.07,5.94-2.87,12-7,16.42s-10.17,8.93-15.46,6",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,298.23A17,17,0,0,1,475.22,279c1.71-1.39,3.94-2.47,6.07-1.91a5.9,5.9,0,0,1,3.92,5,13.94,13.94,0,0,1-1.11,6.6c-1.09,3-2.57,5.92-5.09,7.82s-6.05,3.68-8.51,1.72",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.62,294.33a24.53,24.53,0,0,0-12.37-25.88c-2.82-1.47-6.3-2.34-9.15-.92s-4.32,5-4.08,8.27,1.79,6.26,3.52,9c2.41,3.88,5.38,7.64,9.51,9.59s9.65,3.44,12.57-.08",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.9,267.14c3.55-11.46-2.47-25.35-12.5-31.92-3.12-2-7.06-3.46-10.54-2.14s-5.61,5.33-5.72,9.14,1.35,7.49,3,10.91c2.36,4.79,5.36,9.51,9.94,12.26s12,5.5,15.78,1.75",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,323.14a3.36,3.36,0,0,1-.11-.55c-.07-.42-.15-.95-.24-1.6-.05-.35-.1-.74-.16-1.15s-.17-.88-.27-1.37c-.18-1-.37-2.09-.7-3.3-.14-.61-.3-1.25-.46-1.91s-.39-1.34-.6-2.05c-.38-1.42-.94-2.89-1.47-4.46a78.89,78.89,0,0,0-10.15-18.92c-1-1.3-1.93-2.59-2.91-3.69l-1.37-1.63-1.34-1.44c-.83-.94-1.65-1.72-2.36-2.41l-1-1-.88-.78-1.2-1.08a2.88,2.88,0,0,1-.4-.4,2.57,2.57,0,0,1,.46.33l1.27,1c.27.23.57.48.9.74l1,.95c.74.68,1.58,1.45,2.43,2.37l1.37,1.43,1.4,1.62c1,1.1,1.93,2.38,3,3.69a81.44,81.44,0,0,1,5.79,9.14,83.2,83.2,0,0,1,4.42,9.89c.52,1.58,1.07,3.06,1.44,4.5.2.71.39,1.4.58,2.06l.43,1.93c.3,1.22.47,2.35.63,3.34.08.49.16.94.23,1.37s.08.81.12,1.17c.06.65.1,1.19.14,1.61A2.15,2.15,0,0,1,461,323.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.77,325.2a.68.68,0,0,1,0-.23c0-.17,0-.39.05-.66.06-.62.13-1.47.23-2.55.06-.55.12-1.17.19-1.83s.06-1.41.11-2.2c0-1.57.2-3.36.15-5.34,0-1,0-2,0-3.12s-.11-2.2-.16-3.36c-.08-2.34-.4-4.81-.68-7.41A105.84,105.84,0,0,0,451,266c-1.19-2.34-2.27-4.58-3.47-6.58-.59-1-1.12-2-1.7-2.92l-1.68-2.61c-1-1.7-2.14-3.11-3.05-4.4-.46-.64-.87-1.24-1.28-1.78l-1.16-1.44-1.58-2-.41-.53c-.08-.12-.13-.18-.12-.19a1,1,0,0,1,.16.16l.44.5,1.66,1.95,1.19,1.42c.42.53.85,1.13,1.32,1.76.93,1.27,2.06,2.68,3.11,4.37l1.72,2.61c.59.91,1.13,1.9,1.73,2.91,1.22,2,2.32,4.24,3.52,6.58a111.92,111.92,0,0,1,6.2,15.95,113.07,113.07,0,0,1,3.49,16.74c.27,2.62.58,5.1.64,7.44,0,1.17.14,2.3.14,3.39s0,2.12,0,3.12c0,2-.14,3.78-.22,5.36-.06.79-.09,1.52-.15,2.2s-.16,1.28-.23,1.83c-.14,1.07-.24,1.92-.32,2.54,0,.27-.07.48-.1.66A.93.93,0,0,1,460.77,325.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.08,213.93a1.91,1.91,0,0,1-.1.21l-.32.6L478.39,217c-.27.49-.59,1-.91,1.63l-1,2-1.15,2.29c-.38.82-.75,1.7-1.16,2.62s-.84,1.88-1.25,2.9-.81,2.09-1.23,3.2c-.22.55-.43,1.11-.65,1.68l-.6,1.76c-.4,1.2-.81,2.43-1.24,3.69-1.57,5.08-3.06,10.74-4.32,16.75s-2.07,11.81-2.7,17.1-.94,10.07-1.05,14.1c-.1,2-.12,3.83-.13,5.43s0,3,0,4.1,0,2,0,2.6v.67a.6.6,0,0,1,0,.23s0-.07,0-.23,0-.4-.05-.67c0-.63-.07-1.5-.12-2.59s-.09-2.51-.09-4.11,0-3.43.06-5.44c.06-4,.43-8.83.94-14.14s1.46-11.11,2.68-17.15,2.76-11.7,4.36-16.79c.44-1.26.86-2.49,1.27-3.69l.61-1.76.66-1.69c.44-1.1.86-2.17,1.26-3.19s.88-2,1.29-2.9.8-1.8,1.2-2.61.81-1.57,1.18-2.28l1-2c.32-.6.66-1.13,1-1.61l1.35-2.22c.14-.24.26-.42.36-.58S480.07,213.92,480.08,213.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.56,283.53a11.85,11.85,0,0,1-.79,1.38c-.54.87-1.29,2.15-2.16,3.76s-1.84,3.55-2.81,5.76a77.31,77.31,0,0,0-2.73,7.36c-.81,2.66-1.43,5.25-1.9,7.62s-.75,4.52-.93,6.34-.29,3.29-.33,4.32a10.12,10.12,0,0,1-.13,1.58,8.22,8.22,0,0,1-.06-1.59c0-1,0-2.51.18-4.34a64.51,64.51,0,0,1,.83-6.4,66.44,66.44,0,0,1,4.66-15.07,63.25,63.25,0,0,1,2.92-5.75c.91-1.59,1.71-2.85,2.3-3.69A9.23,9.23,0,0,1,477.56,283.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.47 318.04 479.04 318.04 475.1 351.31 450.52 351.31 446.47 318.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.66 347.72 450.42 351.31 475.1 351.31 477.95 347.83 447.66 347.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.77,327.82c0,.14-6.76.25-15.09.25s-15.1-.11-15.1-.25,6.76-.24,15.1-.24S477.77,327.69,477.77,327.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.77,330c0,.13-6.76.24-15.09.24s-15.1-.11-15.1-.24,6.76-.24,15.1-.24S477.77,329.9,477.77,330Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.37,332.18c0,.14-6.53.25-14.57.25s-14.57-.11-14.57-.25,6.52-.24,14.57-.24S477.37,332.05,477.37,332.18Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.5,153.72c-19.32,2.27-44.34,1.36-54.43-6.27s-15.91-21-13.75-33.51,12.62-23.4,25.12-25.1c7.64-1,15.77,1.07,22.92-1.83s11.56-10,17.7-14.71c13.48-10.27,34.84-6,45,7.55s11.62,35.67,1.74,49.48-20.45,22.11-44.31,24.39",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.5,153.72c-19.32,2.27-44.34,1.36-54.43-6.27s-15.91-21-13.75-33.51,12.62-23.4,25.12-25.1c7.64-1,15.77,1.07,22.92-1.83s11.56-10,17.7-14.71c13.48-10.27,34.84-6,45,7.55s11.62,35.67,1.74,49.48-20.45,22.11-44.31,24.39",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 363.57,
    cy: 66.68,
    r: 8.88,
    transform: "translate(74.17 296.63) rotate(-48.86)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 363.57,
    cy: 66.68,
    r: 8.88,
    transform: "translate(74.17 296.63) rotate(-48.86)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.31,129.2c1.61-5.16-.86-14.67-5.12-18a13.73,13.73,0,0,0-15.23-.89C416,99,406.68,88.45,395.48,87s-22.86,6.39-25.74,17.31a18.71,18.71,0,0,0-23.37,24.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.64 109.46 392.72 105.22 388.81 100.98 384.89 105.22 380.98 109.46 385.37 109.46 385.37 122.12 392.25 122.12 392.25 109.46 396.64 109.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.64,109.46s-.36,0-1.09,0-1.86.07-3.31.09l.14-.13c0,3,.05,7.42.09,12.66v.22h-.24l-6.87,0h-.25v-.25c0-2.56,0-5.29,0-8.11v-4.55l.26.26h-5l.39-.42,7.87-8.45.15-.16.14.16c2.38,2.62,4.33,4.76,5.68,6.31l1.52,1.73.49.58-.61-.61-1.61-1.65c-1.36-1.39-3.33-3.49-5.76-6.09H389l-7.79,8.52-.18-.42h4.65V114c0,2.82,0,5.55,0,8.11l-.25-.26,6.87,0-.22.23c0-5.24.07-9.62.09-12.66v-.13h.13c1.37,0,2.44.06,3.2.09l.87,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.9,
    y: 52.91,
    width: 48.39,
    height: 35.36,
    transform: "translate(226.63 464.75) rotate(-70.01)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.44,99.37l.08-.23c.05-.15.13-.36.22-.64.21-.58.5-1.41.89-2.49L458,86.65l11.84-32.81.1.2L436.69,42h0l.23-.1L420.35,87.33l-.09-.18L444.37,96l6.7,2.47,1.76.66.61.24-.59-.2-1.75-.62-6.7-2.39-24.24-8.74-.13,0,0-.13c4.64-12.77,10.35-28.5,16.51-45.49l.07-.17.16.06h0L470,53.74l.15.06-.06.15c-4.92,13.46-9.09,24.83-12,32.85-1.47,4-2.63,7.13-3.42,9.3-.4,1.06-.7,1.88-.92,2.45-.1.26-.17.47-.23.62S453.45,99.38,453.44,99.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.75,58.34c0,.09-3.67-1.15-8.13-2.77s-8.05-3-8-3.1,3.68,1.14,8.14,2.77S453.78,58.25,453.75,58.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.05,65.47c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.39-4.69,5.63,1.86,12.51,4.36S461.08,65.38,461.05,65.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.55,69.59c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.39-4.69,5.63,1.86,12.51,4.36S459.58,69.5,459.55,69.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.05,73.71c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.39-4.69,5.63,1.86,12.51,4.36S458.08,73.62,458.05,73.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.55,77.84c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.38-4.7,5.63,1.86,12.5,4.36S456.58,77.74,456.55,77.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05,82c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.38-4.69,5.63,1.86,12.5,4.36S455.08,81.87,455.05,82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.55,86.08c0,.09-5.63-1.86-12.5-4.36s-12.42-4.6-12.38-4.69,5.63,1.86,12.5,4.36S453.58,86,453.55,86.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.54,86c0,.09-3.05-.93-6.75-2.27a69.86,69.86,0,0,1-6.62-2.6c0-.09,3.05.93,6.75,2.27A69.86,69.86,0,0,1,440.54,86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.79,
    cy: 94.87,
    r: 7.18,
    transform: "translate(267.65 518.2) rotate(-78.35)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.61,93.68c.19.37-1.82,1.78-4.49,3.14l-1.25.6-.64.3-.32-.56c-1.17-2-1.82-3.63-1.52-3.82s1.46,1.1,2.77,3l-1-.26,1.22-.65C454.1,94.1,456.42,93.3,456.61,93.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.87,
    y: 84.94,
    width: 30.44,
    height: 24.34,
    transform: "translate(-14.36 81.99) rotate(-14.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,81.49l-.14.05-.41.11-1.6.42-6,1.59-21.26,5.58.06-.1c1.82,7,3.92,15,6.13,23.55h0l-.11-.06L330.87,105l-.05.09L326.41,88c-.53-2-.94-3.67-1.22-4.77-.14-.55-.25-1-.32-1.27s-.11-.44-.11-.44l.12.42c.07.29.18.71.33,1.25.29,1.1.72,2.7,1.26,4.75,1.08,4.12,2.63,10,4.49,17.12l0,.07-.07,0-29.46,7.68-.08,0,0-.08h0c-2.21-8.5-4.29-16.54-6.12-23.55l0-.07.08,0,21.33-5.52,6-1.54,1.59-.4.4-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.92,
    y: 86.47,
    width: 28.3,
    height: 21.27,
    transform: "translate(-14.37 81.99) rotate(-14.59)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.06 110.97 308.3 95.68 316.31 102.14 319.21 96.82 329.45 103.84 302.06 110.97",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,91.92a2.23,2.23,0,1,1-2.72-1.6A2.22,2.22,0,0,1,316.33,91.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "302.06 110.97 308.3 95.68 316.31 102.14 319.21 96.82 329.45 103.84 302.06 110.97"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.33,91.92a2.23,2.23,0,1,1-2.72-1.6A2.22,2.22,0,0,1,316.33,91.92Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 311.18,
    y: 62.7,
    width: 46,
    height: 36.77,
    transform: "translate(-4.87 23.7) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.83,61.12a1.18,1.18,0,0,1-.22,0l-.64.05-2.49.19-9.4.69L310,64.48l.11-.13c.77,10.92,1.66,23.44,2.6,36.68h0l-.15-.12,45.89-3.21-.1.12c-.76-11-1.38-20.21-1.82-26.61-.21-3.21-.38-5.72-.5-7.44-.05-.86-.09-1.51-.12-2s0-.69,0-.69,0,.22.06.66.09,1.1.15,1.94c.13,1.72.31,4.22.55,7.41.47,6.42,1.13,15.6,1.94,26.67v.11h-.11l-45.89,3.26h-.13v-.14h0c-.93-13.25-1.81-25.76-2.57-36.68v-.12h.12L343.15,62l9.37-.63,2.47-.16.63,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.77,
    y: 65.01,
    width: 42.77,
    height: 32.14,
    transform: "translate(-4.87 23.7) rotate(-4.03)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.95 98.62 327.45 77.64 337.56 89.46 343.35 82.35 356.61 95.61 313.95 98.62",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42,74.27a3.36,3.36,0,1,1-3.59-3.12A3.36,3.36,0,0,1,340.42,74.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "313.95 98.62 327.45 77.64 337.56 89.46 343.35 82.35 356.61 95.61 313.95 98.62"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.42,74.27a3.36,3.36,0,1,1-3.59-3.12A3.36,3.36,0,0,1,340.42,74.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M382,129.2s0,.16,0,.47V131c0,1.22,0,3,0,5.27,0,4.6-.09,11.26-.16,19.57-.18,16.65-.44,39.87-.73,66.27v.25H361.86l-90.76-.11.15-.15c0,6.69-.05,12-.07,15.62,0,1.8,0,3.19,0,4.14,0,.46,0,.81,0,1.07a2.45,2.45,0,0,1,0,.36s0-.12,0-.36,0-.61,0-1.07c0-.95,0-2.34,0-4.14,0-3.64,0-8.93-.07-15.62V222h.15l90.76-.11h19l-.26.25c.36-26.39.68-49.62.9-66.27.14-8.3.25-15,.32-19.57.05-2.27.09-4,.11-5.26,0-.59,0-1,0-1.37S382,129.2,382,129.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.73,198.22s0-.31,0-.9,0-1.51,0-2.66c0-2.34,0-5.74-.06-10.08,0-8.72-.06-21.17-.1-36.19l.22.22-62.75,0-93.41-.11h-.15v-.15c0-6,.06-10.84.07-14.14,0-1.62,0-2.88,0-3.75,0-.42,0-.74,0-1a1.19,1.19,0,0,1,0-.33,2.06,2.06,0,0,1,0,.33c0,.23,0,.55,0,1,0,.87,0,2.13,0,3.75,0,3.3,0,8.1.06,14.14l-.14-.14,93.41-.12,62.75.05H557v.21c0,15-.07,27.47-.1,36.19,0,4.34,0,7.74-.05,10.08,0,1.15,0,2,0,2.66S556.73,198.22,556.73,198.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.68,240.29,622,266l-24.37-10.38-13.85-7.23-16.92,1.86L590.72,265h0L614,286.91a14.37,14.37,0,0,0,23.43-2.29l19-33.71Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.6,254.52a129.77,129.77,0,0,0-21-5.57c-.44.46.14,2,.67,2.41a5.28,5.28,0,0,0,2.05.94,7.2,7.2,0,0,1,2.06.56,5.55,5.55,0,0,1,2,2.43c1.89,3.06,6.32,5,10.67,4.78",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.07,260.07a1.46,1.46,0,0,1-.45.07,10,10,0,0,1-1.29,0,13.39,13.39,0,0,1-4.64-1.09,11.23,11.23,0,0,1-2.82-1.75,9.17,9.17,0,0,1-1.28-1.35c-.39-.52-.7-1.11-1-1.65A3.22,3.22,0,0,0,577.2,253a8.78,8.78,0,0,0-2-.5,5.41,5.41,0,0,1-2.07-1,2.53,2.53,0,0,1-.69-1,2.77,2.77,0,0,1-.22-1.24,1,1,0,0,1,.22-.5l.09-.1.14,0a103.19,103.19,0,0,1,14.94,3.69c1.87.61,3.37,1.13,4.4,1.5a11.28,11.28,0,0,1,1.58.64,10.27,10.27,0,0,1-1.64-.45l-4.44-1.34a121.34,121.34,0,0,0-14.92-3.52l.23-.08a.55.55,0,0,0-.08.2,2.63,2.63,0,0,0,.7,1.81,5.15,5.15,0,0,0,1.86.89,8.8,8.8,0,0,1,2.1.55,3.7,3.7,0,0,1,1.55,1.48,9.83,9.83,0,0,0,4.88,4.68,14.25,14.25,0,0,0,4.5,1.22C589.45,260.06,590.07,260,590.07,260.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.45,331.32l-22.21,11.5L469.61,347a6.12,6.12,0,0,1-8.64.58l-31.08-27.11s1.26-4.4,4.4-3.38,27.88,8.49,27.88,8.49l20.69-12.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.45,331.32l-22.21,11.5L469.61,347a6.12,6.12,0,0,1-8.64.58l-31.08-27.11s1.26-4.4,4.4-3.38,27.88,8.49,27.88,8.49l20.69-12.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.14,330.69l-5.42,9.89v11.65H472.35s-1.94-4.14,1.1-5.43S500,334.86,500,334.86l9.82-14.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.14,330.69l-5.42,9.89v11.65H472.35s-1.94-4.14,1.1-5.43S500,334.86,500,334.86l9.82-14.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M553.85,265.42s-12.84,1-17.43,4-62.1,44.3-62.1,44.3l14.18,22.45,39.67-18.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M553.85,265.42s-12.84,1-17.43,4-62.1,44.3-62.1,44.3l14.18,22.45,39.67-18.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M690.56,316s-4.89,21.42-6.14,24.72c-1.77,4.64-20,15.16-42.22,9.47-23-5.87-77.68-50.32-77.68-50.32l-5.48,4-34.21,31.77s-19.64-8.1-19.64-16.22c0,0,41.58-63.46,45.37-64.65s7.68-2.38,12.28-1.41,73.76,38.88,73.76,38.88h0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M690.56,316s-4.89,21.42-6.14,24.72c-1.77,4.64-20,15.16-42.22,9.47-23-5.87-77.68-50.32-77.68-50.32l-5.48,4-34.21,31.77s-19.64-8.1-19.64-16.22c0,0,41.58-63.46,45.37-64.65s7.68-2.38,12.28-1.41,73.76,38.88,73.76,38.88h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M547.06,288.72a3.53,3.53,0,0,1,.22.88,11.47,11.47,0,0,0,.7,2.32l.35.72c.06.13.12.25.19.38l.25.37.52.76.66.74a12.76,12.76,0,0,0,3.52,2.59,22.18,22.18,0,0,0,7.69,2.17c2.06.22,3.35.15,3.36.24a3.43,3.43,0,0,1-.91.13,16.76,16.76,0,0,1-2.48,0,20.23,20.23,0,0,1-7.9-2.08,12.45,12.45,0,0,1-3.63-2.73l-.67-.78-.53-.81-.25-.39-.18-.41-.34-.76a9.19,9.19,0,0,1-.55-2.43A2.76,2.76,0,0,1,547.06,288.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.52,299.89a2.78,2.78,0,0,1-.8-.45,24.38,24.38,0,0,1-2-1.46,21.58,21.58,0,0,1-5.43-6.19,20.69,20.69,0,0,1-2.45-7.86,23.55,23.55,0,0,1-.18-2.49,3.69,3.69,0,0,1,0-.92c.09,0,.18,1.3.51,3.36a23,23,0,0,0,2.54,7.66,23.75,23.75,0,0,0,5.22,6.16C563.51,299.06,564.57,299.81,564.52,299.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.83,335.68a3,3,0,0,1-.47-.15L523,335a44.77,44.77,0,0,1-5-2.27,38,38,0,0,1-7.08-4.69,27.59,27.59,0,0,1-3.68-3.72,16.87,16.87,0,0,1-2.94-5l0-.09.07-.1,13.44-19.86c7.9-11.6,15.22-22,20.67-29.41,2.72-3.71,5-6.68,6.52-8.72l1.82-2.34.48-.6.18-.2s0,.09-.13.23l-.44.63q-.64.87-1.74,2.4l-6.39,8.82c-5.37,7.47-12.64,17.88-20.54,29.49-4.91,7.2-9.52,14-13.49,19.82l0-.19a16.65,16.65,0,0,0,2.83,4.87,26.41,26.41,0,0,0,3.6,3.7,38.64,38.64,0,0,0,7,4.74,51.74,51.74,0,0,0,4.91,2.38l1.33.57A3.4,3.4,0,0,1,524.83,335.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.07,330.91a4.82,4.82,0,0,1-.76-.79c-.47-.52-1.11-1.31-1.89-2.29a92.89,92.89,0,0,1-5.65-8,93.87,93.87,0,0,1-4.78-8.57c-.55-1.14-1-2.06-1.25-2.71a3.93,3.93,0,0,1-.37-1,4.79,4.79,0,0,1,.56.94c.38.72.84,1.6,1.39,2.63,1.17,2.21,2.86,5.23,4.89,8.47s4,6.06,5.5,8.09l1.76,2.39A4.39,4.39,0,0,1,498.07,330.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.27,315.63a13,13,0,0,1-1.9-2.3,58.3,58.3,0,0,1-6.91-12.58,12.82,12.82,0,0,1-.92-2.84,23,23,0,0,1,1.26,2.69c.75,1.67,1.84,4,3.18,6.4s2.69,4.59,3.7,6.12A23.65,23.65,0,0,1,506.27,315.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.15,300.13a7.91,7.91,0,0,1-1.37-1.6,40.38,40.38,0,0,1-2.75-4.29,39.4,39.4,0,0,1-2.17-4.61,7.5,7.5,0,0,1-.62-2c.15-.06,1.33,2.92,3.25,6.37S518.28,300,518.15,300.13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.67,283.13a3.3,3.3,0,0,1-.45.44l-1.36,1.2c-1.17,1-2.9,2.49-5.06,4.28-4.31,3.57-10.34,8.41-17.16,13.56s-13.13,9.64-17.75,12.8c-2.31,1.58-4.19,2.84-5.5,3.7l-1.52,1a2.4,2.4,0,0,1-.55.31,3.48,3.48,0,0,1,.49-.4l1.46-1.05,5.41-3.83c4.56-3.24,10.83-7.77,17.65-12.91s12.87-9.94,17.24-13.44l5.17-4.15,1.41-1.12A2.77,2.77,0,0,1,528.67,283.13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.55,321a20.9,20.9,0,0,1-3,1.37c-1.85.8-4.41,1.92-7.2,3.24s-5.28,2.58-7.08,3.51a22.21,22.21,0,0,1-3,1.43,20.07,20.07,0,0,1,2.78-1.75c1.76-1,4.23-2.34,7-3.66s5.39-2.39,7.28-3.11A18.72,18.72,0,0,1,505.55,321Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.17,261.65a9.36,9.36,0,0,1-1.32-.76c-.84-.52-2.05-1.27-3.58-2.13a36.19,36.19,0,0,0-5.57-2.59,16.3,16.3,0,0,0-7.3-1.08,15.45,15.45,0,0,0-6.8,2.86,36.11,36.11,0,0,0-4.67,4c-1.24,1.24-2.21,2.28-2.88,3A7.69,7.69,0,0,1,542,266a8.22,8.22,0,0,1,.93-1.21c.62-.77,1.55-1.85,2.77-3.13a33.08,33.08,0,0,1,4.66-4.12,15.6,15.6,0,0,1,7-3,16.45,16.45,0,0,1,7.53,1.15,34.63,34.63,0,0,1,5.58,2.72c1.52.91,2.7,1.71,3.51,2.28A8.36,8.36,0,0,1,575.17,261.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.82,296.91a10.75,10.75,0,0,1-.49-1.64c-.3-1.07-.66-2.62-1.07-4.56a113.15,113.15,0,0,1-2-30.73c.15-2,.31-3.56.46-4.66a11.54,11.54,0,0,1,.27-1.69,10,10,0,0,1-.07,1.71c-.09,1.1-.19,2.69-.29,4.66a135.8,135.8,0,0,0,.11,15.38,134.17,134.17,0,0,0,1.91,15.26c.35,1.94.66,3.5.89,4.58A9.6,9.6,0,0,1,559.82,296.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.49,352.23c0,.15-63,.26-140.71.26s-140.73-.11-140.73-.26,63-.26,140.73-.26S702.49,352.09,702.49,352.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.47,328a4.62,4.62,0,0,1-1-.31,25.79,25.79,0,0,1-2.72-1.11,32.07,32.07,0,0,1-8.09-5.36,32.51,32.51,0,0,1-6-7.61,28.37,28.37,0,0,1-1.33-2.62,4.82,4.82,0,0,1-.39-1c.08,0,.75,1.34,2,3.44a33.61,33.61,0,0,0,13.94,12.83C530.08,327.31,531.51,327.86,531.47,328Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34,318.55a5,5,0,0,1-1.09-.42c-.7-.3-1.67-.78-2.85-1.43a47.54,47.54,0,0,1-15.58-13.87,30.69,30.69,0,0,1-1.74-2.66,4.92,4.92,0,0,1-.54-1c.07-.05,1,1.35,2.58,3.47a54.33,54.33,0,0,0,15.46,13.77C539.88,317.75,541.37,318.47,541.34,318.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.74,309.25a6.7,6.7,0,0,1-1.25-.51c-.8-.34-1.92-.9-3.29-1.64a53.56,53.56,0,0,1-9.9-7,64.55,64.55,0,0,1-8.18-8.95c-.93-1.24-1.66-2.25-2.14-3a5.9,5.9,0,0,1-.71-1.15,6.73,6.73,0,0,1,.87,1l2.27,2.88a77.45,77.45,0,0,0,8.23,8.78,61.33,61.33,0,0,0,9.74,7.06c1.34.77,2.43,1.38,3.2,1.78A6.25,6.25,0,0,1,552.74,309.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.09,265c.11,0,0,2.16.35,5.61.11.86.22,1.81.44,2.81s.45,2.05.72,3.17a44,44,0,0,0,2.63,7,43.57,43.57,0,0,0,3.86,6.36c.7.91,1.35,1.78,2,2.53s1.32,1.46,1.94,2.07c2.47,2.44,4.27,3.65,4.2,3.74a7.79,7.79,0,0,1-1.27-.83,15.24,15.24,0,0,1-1.41-1.09c-.53-.45-1.16-.93-1.78-1.55s-1.32-1.27-2-2.05-1.39-1.62-2.11-2.53a38.6,38.6,0,0,1-6.56-13.49c-.27-1.13-.54-2.2-.69-3.22a27.07,27.07,0,0,1-.37-2.84,23.07,23.07,0,0,1-.13-2.36,14.76,14.76,0,0,1,0-1.78A9,9,0,0,1,543.09,265Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,260.8a8.77,8.77,0,0,1-.73,1.36c-.26.43-.57,1-.89,1.59s-.73,1.32-1.09,2.13a52.89,52.89,0,0,0-2.36,5.77,53.74,53.74,0,0,0-1.89,7.39,54.52,54.52,0,0,0-.75,7.59,53.1,53.1,0,0,0,.25,6.23c.06.89.2,1.68.3,2.38s.19,1.3.29,1.79a8.83,8.83,0,0,1,.22,1.54,10.55,10.55,0,0,1-.42-1.5,16.75,16.75,0,0,1-.38-1.78c-.12-.7-.29-1.5-.38-2.39a46.28,46.28,0,0,1-.36-6.28,52.35,52.35,0,0,1,.71-7.67,51.35,51.35,0,0,1,2-7.45,46.28,46.28,0,0,1,2.48-5.78c.39-.81.82-1.5,1.17-2.12a18.12,18.12,0,0,1,1-1.54A9.11,9.11,0,0,1,571,260.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.6,269.26a10.17,10.17,0,0,1-1.12,1.19c-.38.36-.83.82-1.33,1.37s-1.1,1.16-1.69,1.89a53.44,53.44,0,0,0-4,5.23,59.35,59.35,0,0,0-4,7,58.48,58.48,0,0,0-2.88,7.52,55.56,55.56,0,0,0-1.5,6.41c-.18.92-.26,1.77-.37,2.5s-.17,1.38-.21,1.9a9.32,9.32,0,0,1-.21,1.63,10.81,10.81,0,0,1,0-1.64c0-.53,0-1.17.12-1.92s.14-1.6.3-2.53a50.54,50.54,0,0,1,1.4-6.48,55.19,55.19,0,0,1,2.87-7.61,56.05,56.05,0,0,1,4-7.06,50.26,50.26,0,0,1,4.11-5.21c.61-.72,1.24-1.31,1.76-1.84s1-1,1.4-1.32A9.35,9.35,0,0,1,590.6,269.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.61,279.67a10.28,10.28,0,0,1-.73,1.5c-.49.95-1.24,2.31-2.18,4-1.88,3.34-4.57,7.91-7.69,12.86s-6.09,9.34-8.3,12.48c-1.1,1.56-2,2.82-2.65,3.68a10.14,10.14,0,0,1-1,1.3,13,13,0,0,1,.88-1.42l2.52-3.77c2.13-3.19,5-7.61,8.16-12.55s5.85-9.48,7.81-12.77l2.33-3.9A10,10,0,0,1,608.61,279.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.22,288.92s-.05.15-.19.43l-.63,1.17c-.56,1-1.4,2.47-2.48,4.24-2.15,3.55-5.29,8.35-9.08,13.42s-7.52,9.44-10.31,12.5c-1.4,1.54-2.55,2.76-3.37,3.58l-.95.94a1.78,1.78,0,0,1-.35.3s.08-.14.28-.38l.87-1,3.24-3.68c2.72-3.12,6.38-7.52,10.17-12.57s7-9.81,9.19-13.3l2.61-4.15.72-1.13A1.87,1.87,0,0,1,629.22,288.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647,301.34a1.4,1.4,0,0,1-.11.46l-.4,1.28c-.18.55-.41,1.23-.72,2s-.62,1.66-1,2.61a72.36,72.36,0,0,1-3.23,6.58A72.54,72.54,0,0,1,631,328.74a70.22,70.22,0,0,1-5.28,5.08c-.78.7-1.53,1.28-2.17,1.8s-1.21.95-1.69,1.29l-1.09.78a2.14,2.14,0,0,1-.4.24s.1-.13.33-.33l1-.85c.45-.36,1-.81,1.63-1.35s1.35-1.14,2.1-1.85c1.55-1.39,3.31-3.12,5.18-5.13a88.53,88.53,0,0,0,5.66-6.89,86,86,0,0,0,4.84-7.5c1.34-2.39,2.46-4.59,3.3-6.49.46-.93.8-1.81,1.12-2.57s.59-1.42.8-2,.36-.9.49-1.24A1.59,1.59,0,0,1,647,301.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.58,318.16a7.22,7.22,0,0,1-.44,1.43c-.31.92-.83,2.22-1.53,3.81a66.47,66.47,0,0,1-15.75,21.81c-1.28,1.16-2.35,2.06-3.12,2.65a9,9,0,0,1-1.23.88,8.21,8.21,0,0,1,1.1-1c.73-.63,1.76-1.57,3-2.76a74.09,74.09,0,0,0,15.66-21.7c.74-1.55,1.31-2.83,1.68-3.72A9.48,9.48,0,0,1,662.58,318.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.92,327a4.77,4.77,0,0,1-.22,1c-.17.66-.47,1.61-.87,2.76a57.47,57.47,0,0,1-9.25,16.65c-.77,1-1.41,1.71-1.88,2.2s-.74.77-.77.74.91-1.21,2.36-3.16a74.64,74.64,0,0,0,5.16-8,72.22,72.22,0,0,0,4-8.59C679.37,328.36,679.84,326.92,679.92,327Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,294.27a2,2,0,0,1-.24.41c-.21.3-.47.66-.77,1.1-.67,1-1.68,2.31-2.93,4-2.52,3.33-6.09,7.85-10.21,12.7s-8,9.11-10.9,12.13c-1.44,1.51-2.62,2.71-3.45,3.53l-1,.94a2,2,0,0,1-.36.3s.08-.14.28-.38l.9-1,3.32-3.64c2.81-3.08,6.65-7.37,10.77-12.21s7.73-9.33,10.32-12.59l3.06-3.87.84-1.05C548.91,294.38,549,294.26,549,294.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.85,287.34c.06.15-1.4.84-3,2s-2.77,2.26-2.89,2.16a7.74,7.74,0,0,1,2.59-2.58A7.65,7.65,0,0,1,553.85,287.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.08,351.16l-.31-.07-.88-.24c-.76-.24-1.92-.52-3.36-1a97.63,97.63,0,0,1-12-4.86A130.79,130.79,0,0,1,626,335.29c-6-4.07-12.27-8.91-18.8-14.07S594.43,311.17,588.55,307a159.94,159.94,0,0,0-16.15-10.24,110,110,0,0,0-11.64-5.54c-1.41-.6-2.53-1-3.28-1.26l-.85-.34c-.19-.07-.29-.12-.28-.13l.3.08.87.29c.75.27,1.89.6,3.31,1.17a99.2,99.2,0,0,1,11.74,5.41,154.75,154.75,0,0,1,16.25,10.17c5.92,4.15,12.17,9,18.71,14.19s12.8,10,18.74,14.08a133.45,133.45,0,0,0,16.44,9.75,102.33,102.33,0,0,0,11.88,5c1.43.53,2.58.85,3.33,1.12l.87.29A1.48,1.48,0,0,1,659.08,351.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.2,342.76s-3.08-.61-8.53-2.19a147.72,147.72,0,0,1-22.36-8.75,233,233,0,0,1-30.59-18.22,408.85,408.85,0,0,1-34.36-26.85c-7.43-6.38-14.51-12.7-21.15-18.63l.07,0-4.4-1.82.1,0a12.53,12.53,0,0,0-7.6,2.94,37.73,37.73,0,0,0-5.63,5.75q-5,6.19-9.51,11.79c-6,7.47-11.17,14.14-15.37,19.75s-7.45,10.16-9.63,13.3l-2.5,3.61-.65.93a3,3,0,0,1-.23.31,3.47,3.47,0,0,1,.2-.33l.61-1c.54-.83,1.35-2.07,2.43-3.65,2.14-3.17,5.34-7.75,9.52-13.39s9.33-12.34,15.29-19.83l9.48-11.82a36.93,36.93,0,0,1,5.7-5.84,12.81,12.81,0,0,1,7.89-3.05h.09l4.4,1.82h0l0,0c6.65,5.92,13.73,12.24,21.15,18.61A417.8,417.8,0,0,0,621,313.21a237.48,237.48,0,0,0,30.48,18.28,152,152,0,0,0,22.26,8.88c2.71.81,4.82,1.42,6.27,1.78l1.64.44C682,342.69,682.2,342.76,682.2,342.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.12,307l-.23,0h-.68c-.59,0-1.47,0-2.59-.1a51,51,0,0,1-9.41-1.62A68.69,68.69,0,0,1,629,300.18a107.86,107.86,0,0,1-14.77-9.08c-5-3.62-9.52-7.33-13.64-10.71s-7.8-6.43-11-8.91-5.79-4.42-7.62-5.71l-2.12-1.49-.55-.4-.18-.15s.08,0,.21.11l.58.35c.49.32,1.24.77,2.17,1.41,1.88,1.25,4.53,3.14,7.73,5.59s6.93,5.47,11.06,8.83,8.67,7.05,13.63,10.65a110.43,110.43,0,0,0,14.68,9.08,70.77,70.77,0,0,0,13.1,5.16,54.38,54.38,0,0,0,9.33,1.76c1.11.15,2,.15,2.58.21l.67.05A.89.89,0,0,1,655.12,307Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.83,279.7h0a3.53,3.53,0,0,0-1.12-4.91l-41.47-25.48-7.55-51.9a2.94,2.94,0,0,0-3-2.52h0a2.94,2.94,0,0,0-2.86,3.33l7.25,54.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.64,197.18c1.16,1.13,17.33,7.4,18.81,20.64.66,5.91-14.73,105.44-14.73,105.44l-1.8.53a26.7,26.7,0,0,1-28.75-9.49l-3-4.08a39.21,39.21,0,0,0-8.7-8.5l-16.33-12.44L643,278.38l-1.16-12.11s-5.23-18.56-2.32-27.86,16.88-28.81,16.88-28.81l6.93-7.81Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.71,313.06a3.19,3.19,0,0,1-.73.57,8.76,8.76,0,0,1-.91.57,13.71,13.71,0,0,1-1.28.65,18.19,18.19,0,0,1-3.53,1.18,19.32,19.32,0,0,1-9.07-.14,18.47,18.47,0,0,1-3.49-1.3,14,14,0,0,1-1.26-.69,8,8,0,0,1-.89-.6c-.48-.36-.73-.56-.71-.59s1.11.69,3,1.54a19.36,19.36,0,0,0,3.46,1.17,20.23,20.23,0,0,0,8.85.14,20.56,20.56,0,0,0,3.49-1.05C686.58,313.72,687.65,313,687.71,313.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.78,304.59a6.75,6.75,0,0,1-1.67,1.33,18.22,18.22,0,0,1-9.81,2.82,6,6,0,0,1-2.12-.24,33.52,33.52,0,0,0,7.08-1A34.93,34.93,0,0,0,686.78,304.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.24,202.75s-16.27-3.9-20.33,11.7A267,267,0,0,1,660.1,246l37.23,7.83S709.49,212.49,691.24,202.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.33,253.82a3.81,3.81,0,0,1-.74-.11l-2.13-.4-7.87-1.57L660,246.24l-.29-.06.11-.28c.76-2,1.51-4,2.24-6.16,2-5.83,3.67-11.45,5-16.62.32-1.29.58-2.57.93-3.79s.74-2.4,1.16-3.51.85-2.19,1.28-3.2a15.91,15.91,0,0,1,1.43-2.86,14.89,14.89,0,0,1,3.89-3.85A17.06,17.06,0,0,1,679.4,204a9.47,9.47,0,0,1,2.54-.63,4,4,0,0,1,.91,0s-.32,0-.9.11a10.93,10.93,0,0,0-2.47.72,17.73,17.73,0,0,0-3.56,2,15.17,15.17,0,0,0-3.75,3.82,15.61,15.61,0,0,0-1.37,2.81c-.42,1-.85,2.08-1.25,3.19s-.78,2.28-1.12,3.49-.59,2.48-.91,3.78c-1.26,5.2-2.94,10.84-4.93,16.68-.73,2.13-1.49,4.21-2.25,6.18l-.19-.35,26.51,5.66,7.84,1.73,2.11.49A5.53,5.53,0,0,1,697.33,253.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.41,263.5a4.23,4.23,0,0,1-1.71-.36,12.33,12.33,0,0,1-6.46-5.26,4.11,4.11,0,0,1-.7-1.6,22.84,22.84,0,0,0,3.8,4.39A22.39,22.39,0,0,0,655.41,263.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.44,247.32a6.67,6.67,0,0,1,.24-1.4c.21-.89.46-2.19.74-3.8a70.62,70.62,0,0,0-.19-25.33c-.3-1.6-.58-2.89-.79-3.78a6.64,6.64,0,0,1-.27-1.4,7.53,7.53,0,0,1,.46,1.35c.28.87.61,2.16,1,3.76a62.79,62.79,0,0,1,.19,25.47c-.32,1.61-.64,2.9-.9,3.78A7.75,7.75,0,0,1,698.44,247.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.14,191.55c1.43,4.11-1.07,8.5-3.75,11.93s-5.83,7-5.88,11.37c0,2.35.86,4.59,1.47,6.86s.92,4.8-.2,6.86c-1.3,2.37-4.18,3.56-5.38,6a7.07,7.07,0,0,0,.05,5.7,21,21,0,0,0,3.17,4.92c.61.78,1.51,1.64,2.43,1.31a2.37,2.37,0,0,0,1.15-1.33q7.57-15.26,14.3-30.92a22.9,22.9,0,0,0,2.12-7c.41-5.09-2.57-10-2.1-15.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.54,143.66c-4.24,2.69-5.93,8.35-5.12,11.69.4,1.69,1.17,3.38.83,5.08-.28,1.47-1.34,2.65-2.13,3.92a11.8,11.8,0,0,0,14.75,17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644,165.73c-10.32-22.7,14.22-34.09,27.61-30.31,12.59,3.55,18,9.81,20,18.23s2,17.54-1.33,25.56c-1.63,3.95-4.56,8-8.81,8.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656,212.77c-.18-10.84-.21-17.29-.21-17.23s-9.32-1.55-11.25-13.7c-1-6.05-.66-16-.15-24.07.46-7.29,5.3-16.24,12.56-15.47l22.7,5.73a4.29,4.29,0,0,1,3.83,4.34h0L682,199.31",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.14,165.74a1.54,1.54,0,0,0,1.48,1.58,1.48,1.48,0,0,0,1.61-1.37,1.56,1.56,0,0,0-1.47-1.59A1.49,1.49,0,0,0,647.14,165.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663,165.74a1.54,1.54,0,0,0,1.47,1.58,1.49,1.49,0,0,0,1.62-1.37,1.57,1.57,0,0,0-1.48-1.59A1.48,1.48,0,0,0,663,165.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.79,162.36c.19.21,1.4-.62,3.08-.56s2.87.94,3.06.74-.09-.46-.61-.87a4.26,4.26,0,0,0-2.45-.84,4.08,4.08,0,0,0-2.45.7C646.89,161.91,646.7,162.27,646.79,162.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.72,162.76c.19.21,1.37-.67,3-.68s2.91.84,3.09.63-.11-.46-.65-.85a4.31,4.31,0,0,0-2.47-.75,4.07,4.07,0,0,0-2.43.8C662.8,162.31,662.62,162.67,662.72,162.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657,175.69a10.84,10.84,0,0,0-2.73-.5c-.42,0-.83-.13-.9-.42a2.24,2.24,0,0,1,.28-1.27c.41-1,.83-2.12,1.27-3.26,1.76-4.65,3-8.47,2.85-8.53s-1.77,3.64-3.53,8.28c-.42,1.15-.83,2.24-1.21,3.28a2.49,2.49,0,0,0-.23,1.68,1.08,1.08,0,0,0,.71.63,2.89,2.89,0,0,0,.73.1A11.57,11.57,0,0,0,657,175.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.81,195.54a30.9,30.9,0,0,0,16.28-4.34s-4.11,8.46-16.28,7.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.68,179.73a3,3,0,0,1,2.71-1.12,2.76,2.76,0,0,1,1.91,1,1.76,1.76,0,0,1,.13,2,2,2,0,0,1-2.2.56,6.57,6.57,0,0,1-2.15-1.28,2.07,2.07,0,0,1-.48-.5.57.57,0,0,1,0-.63",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.91,176.85c-.28,0-.28,1.8-1.84,3.09s-3.5,1.1-3.51,1.35.43.36,1.25.38a4.5,4.5,0,0,0,2.93-1,4,4,0,0,0,1.43-2.6C662.23,177.29,662,176.84,661.91,176.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.3,160.3c.17.46,1.84.24,3.81.48s3.56.78,3.82.37c.12-.2-.16-.63-.8-1.07a6.67,6.67,0,0,0-5.81-.64C662.6,159.73,662.23,160.09,662.3,160.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.18,158.07c.3.38,1.45,0,2.84,0s2.57.26,2.84-.14c.12-.2-.07-.58-.58-.94a3.92,3.92,0,0,0-2.31-.62,4,4,0,0,0-2.27.76C647.21,157.49,647.05,157.89,647.18,158.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.41,168.3c.18-.08,6.51-2.88,6.58,4.4s-7.25,5.85-7.26,5.64S681.41,168.3,681.41,168.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.92,175.56s.13.09.35.18a1.2,1.2,0,0,0,.94,0,3.13,3.13,0,0,0,1.43-2.83,4.22,4.22,0,0,0-.38-1.81,1.43,1.43,0,0,0-1-1,.63.63,0,0,0-.74.35c-.1.21,0,.35-.09.36s-.16-.12-.1-.42a.86.86,0,0,1,.28-.46,1,1,0,0,1,.7-.19,1.8,1.8,0,0,1,1.34,1.12,4.39,4.39,0,0,1,.46,2c0,1.47-.77,2.85-1.82,3.16a1.35,1.35,0,0,1-1.16-.18C682.94,175.73,682.9,175.57,682.92,175.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.55,138.63c-4,2.1-5.72,10.38-4,14.62s6.19,6.31,10.64,7.29a26.85,26.85,0,0,0,13.21-.14c.31,3,2.08,6,4.95,6.77,3.79,1,7.61-2.44,8.46-6.28s-.42-7.8-1.67-11.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.67,165.05s-.18.21-.56.53a20,20,0,0,1-1.68,1.26,10.22,10.22,0,0,1-2.83,1.37,6.15,6.15,0,0,1-3.86-.05,6,6,0,0,1-2.93-2.53,8.06,8.06,0,0,1-1-3,11.32,11.32,0,0,1-.11-2.11,2.67,2.67,0,0,1,.09-.77c.08,0,0,1.11.32,2.82a8.22,8.22,0,0,0,1.08,2.82,5.72,5.72,0,0,0,2.74,2.34,5.88,5.88,0,0,0,3.61.08,10.89,10.89,0,0,0,2.78-1.25C685.76,165.66,686.63,165,686.67,165.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.71,200.84a20.79,20.79,0,0,0-3-5.05l-.59-.81c3.24-2.38,4.56-6.25,4-11.17-.36-2.93-1.51-4.91-6.18-10.66a31.92,31.92,0,0,1-6.67-16.82L689,165.64l1.29,10.68-3.09,6.37-1.91.79-3-4.89c-2,5.49-4,7.21-8.1,10s-8.21,4.53-11.56,10.46c-.93,1.64-7.21,23.95-6.11,24.94,0,0,11.68-12.68,15.53-16.23,4.57-4.21,8.56-5.89,14.14-5.42,3.94.7,6.43.66,9.22,3.54,1.32,1.36,2.6,3,4.46,3.36a4.62,4.62,0,0,0,4.77-2.68A7.48,7.48,0,0,0,704.71,200.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.9,195.92s-.13-.27-.46-.73a6.21,6.21,0,0,0-1.85-1.64A17.48,17.48,0,0,0,696,192a22.78,22.78,0,0,1-2.3-.91,7.75,7.75,0,0,1-2.31-1.55,5.88,5.88,0,0,1-1.52-2.65,9.08,9.08,0,0,1-.23-3.31c.19-2.31,1.2-4.58,2-7a14.22,14.22,0,0,0,.74-3.82,7.87,7.87,0,0,0-.87-3.9,5.22,5.22,0,0,0-1.3-1.58,4.88,4.88,0,0,0-1.88-.89c-.68-.17-1.4-.27-2.12-.43a5.37,5.37,0,0,1-2.08-.84,4.52,4.52,0,0,1-1.36-1.78c-.32-.67-.56-1.36-.85-2a6.33,6.33,0,0,0-2.78-3,10.88,10.88,0,0,0-3.85-1.21,27.06,27.06,0,0,0-3.91-.14c-1.28,0-2.53.06-3.75,0a14.76,14.76,0,0,1-9-3.7,14.08,14.08,0,0,1-3.2-4.13,14.65,14.65,0,0,1-1.32-3.73,13.59,13.59,0,0,1-.29-2.49,8.3,8.3,0,0,1,0-.87,2,2,0,0,1,0,.22c0,.15,0,.37,0,.65a14.35,14.35,0,0,0,.34,2.47,14.77,14.77,0,0,0,1.34,3.68,14.1,14.1,0,0,0,3.2,4.07,14.75,14.75,0,0,0,5.47,3,14.31,14.31,0,0,0,3.45.58c1.21.07,2.46,0,3.74,0a25.11,25.11,0,0,1,3.95.13,10.91,10.91,0,0,1,3.94,1.24,7.26,7.26,0,0,1,1.69,1.3,6.56,6.56,0,0,1,1.19,1.83c.3.66.54,1.35.85,2a4.24,4.24,0,0,0,1.28,1.68,5,5,0,0,0,2,.8c.71.16,1.43.25,2.14.44a5.06,5.06,0,0,1,2,.94,5.39,5.39,0,0,1,1.36,1.65,8.18,8.18,0,0,1,.89,4,14.51,14.51,0,0,1-.75,3.88c-.78,2.45-1.79,4.7-2,7a8.92,8.92,0,0,0,.21,3.24,5.74,5.74,0,0,0,1.46,2.58,8,8,0,0,0,2.25,1.53,24,24,0,0,0,2.28.91,17.38,17.38,0,0,1,3.61,1.62,6.25,6.25,0,0,1,1.83,1.69A4,4,0,0,1,701.9,195.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.11,190.72s0-.05.16-.12.27-.17.47-.33a6.76,6.76,0,0,0,1.52-1.6,8.53,8.53,0,0,0,1.34-3.21,10.45,10.45,0,0,0-.11-4.6,16.81,16.81,0,0,0-2.3-5.11,57.36,57.36,0,0,0-3.92-5.17,35.09,35.09,0,0,1-4.12-5.9c-1.2-2.22-1.66-4.81-2.66-7.24a9.85,9.85,0,0,0-2.06-3.24,11.29,11.29,0,0,0-3-2.16,26.78,26.78,0,0,0-6.85-2,47.89,47.89,0,0,1-6.32-1.55,27,27,0,0,1-5.19-2.3,18.13,18.13,0,0,1-6-5.52,13.58,13.58,0,0,1-1.1-1.95c-.11-.23-.18-.41-.23-.53s-.07-.19-.06-.19l.09.18c.06.12.13.29.25.52a13.85,13.85,0,0,0,1.13,1.91,18.38,18.38,0,0,0,6,5.42,27.09,27.09,0,0,0,5.17,2.26,50.15,50.15,0,0,0,6.3,1.52,26.89,26.89,0,0,1,6.91,2,11.34,11.34,0,0,1,3.12,2.2,10.24,10.24,0,0,1,2.12,3.32c1,2.47,1.47,5,2.64,7.23a35.73,35.73,0,0,0,4.08,5.87,55.18,55.18,0,0,1,3.91,5.2,17.08,17.08,0,0,1,2.31,5.18,10.56,10.56,0,0,1,.07,4.67,8.69,8.69,0,0,1-1.4,3.24,6.61,6.61,0,0,1-1.57,1.58A6.18,6.18,0,0,1,699.11,190.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.89,204.58a1.65,1.65,0,0,1,0-.38,9.54,9.54,0,0,1,0-1.11,12.23,12.23,0,0,1,.88-4,15.64,15.64,0,0,1,3.28-5,23.85,23.85,0,0,1,5.94-4.36c2.31-1.24,4.68-2,6.66-3.13a14.43,14.43,0,0,0,2.64-1.76,9,9,0,0,0,1.79-2.1,6.86,6.86,0,0,0,1.1-3.8,7.61,7.61,0,0,0-.25-1.45,1.47,1.47,0,0,1,.14.36,4.65,4.65,0,0,1,.21,1.08,6.8,6.8,0,0,1-1,3.9,8.93,8.93,0,0,1-1.81,2.16,13.91,13.91,0,0,1-2.67,1.82c-2,1.1-4.36,1.91-6.65,3.15a23.45,23.45,0,0,0-5.89,4.3,15.64,15.64,0,0,0-3.28,4.94,12.43,12.43,0,0,0-1,3.9c0,.47,0,.84,0,1.1S663.89,204.58,663.89,204.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.41,147.2s-.12-.4-.43-1.08a7.73,7.73,0,0,0-1.92-2.45,11.23,11.23,0,0,0-4.08-2.16,30,30,0,0,0-5.64-.93,46.28,46.28,0,0,1-10.26-2c-1.28-.4-2.29-.78-3-1.07-.35-.13-.62-.25-.8-.33s-.27-.13-.26-.14a1,1,0,0,1,.28.09l.81.29c.7.26,1.72.61,3,1a50.67,50.67,0,0,0,10.24,1.9,28.63,28.63,0,0,1,5.68,1,11,11,0,0,1,4.13,2.25,7.33,7.33,0,0,1,1.89,2.54,5.69,5.69,0,0,1,.28.82A1.11,1.11,0,0,1,687.41,147.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.27,136.29c-1.6-2.6-.8-6.18,1.27-8.43a13.81,13.81,0,0,1,8.12-3.82,12.34,12.34,0,0,1,6.33.35,6.18,6.18,0,0,1,4.08,4.57c.36,2.34-1,4.62-2.75,6.26a2.67,2.67,0,0,0-1.07,1.67c0,.72.56,1.3,1,1.85a5.65,5.65,0,0,1,1.48,3.87,3.73,3.73,0,0,1-2.25,3.31c-1.43.54-3,0-4.43-.59l-8.87-3.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.85,144.38c-.11.12-2.64-2.18-6.2-4.39s-6.72-3.49-6.66-3.64a8.25,8.25,0,0,1,2.13.71,34,34,0,0,1,9.16,5.71A8.07,8.07,0,0,1,688.85,144.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.45,247.41l-9.79,23.72-42.79-8.22S594.55,248.67,594,248.2l-5.27.73-8.64-.23-7.67,4.14-1.3.23,35.69,22.11,41.46,23.6A20.08,20.08,0,0,0,667,300.69h0A20.06,20.06,0,0,0,678.24,289l13.36-36.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.85,252.59a11,11,0,0,1,2.32-.59c1.45-.3,3.45-.68,5.67-1.06l2.08-.36H583l.06,0c1.66.53,3.1,1,4.12,1.36a6.37,6.37,0,0,1,1.59.66,7.57,7.57,0,0,1-1.69-.35c-1-.28-2.5-.69-4.17-1.19H583l-2.07.37c-2.22.39-4.23.71-5.7.91A10.82,10.82,0,0,1,572.85,252.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.06,255.38a49.32,49.32,0,0,1,7-.36l1.68,0h.05l0,0a33.17,33.17,0,0,1,4.78,2.46,32.83,32.83,0,0,1-5-2l.1,0-1.67,0A46,46,0,0,1,575.06,255.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.45,247.41a2.85,2.85,0,0,1-.14.46l-.5,1.29L662.87,254l-7,17.19-.07.17-.19,0-20.55-3.93-22.23-4.3h-.05l0,0-13.64-10.72-3.81-3-1-.82a1.78,1.78,0,0,1-.33-.3,2,2,0,0,1,.37.25l1,.76,3.88,2.94c3.37,2.58,8.1,6.22,13.76,10.58l-.09-.05,22.23,4.24,20.55,4-.26.14,7.17-17.11c.88-2,1.57-3.67,2.06-4.82.24-.53.42-1,.57-1.27A3,3,0,0,1,665.45,247.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.65,288.11a20.93,20.93,0,0,1-.54-2.64,42.46,42.46,0,0,0-1.71-6.23,43.15,43.15,0,0,0-2.67-5.89,20,20,0,0,1-1.28-2.37,10.22,10.22,0,0,1,1.6,2.19,32.88,32.88,0,0,1,2.84,5.89,32.31,32.31,0,0,1,1.59,6.35A10.39,10.39,0,0,1,661.65,288.11Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee-2--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "604.97 351.15 610.01 322.18 583.4 321.95 587.6 351.15 604.97 351.15",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.19,328.51s12-1.16,11.09,8.69-14.41,7.11-14.41,7.11v-3.77s10.66-.18,9.44-4.32-8.3-3.46-8.3-3.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.91,297.34a11.12,11.12,0,0,1,1.21-4.19,11.41,11.41,0,0,1,2.2-2.87,14.8,14.8,0,0,1,2.92-2.17,2.1,2.1,0,0,1,.6-.24,1.92,1.92,0,0,0,.54-.32,6.63,6.63,0,0,0,1.69-2.54,6.1,6.1,0,0,1,1.37-2.38c.64-.52,1.78-.54,3.06.55a7.84,7.84,0,0,1,2.31,6.53,9.49,9.49,0,0,1-.54,2.54,12.23,12.23,0,0,1-1.28,2.5c-1,1.44-1.89,2.46-2.2,3.07l-.08.17H592l0,0a.93.93,0,0,1,.08.17,6.26,6.26,0,0,0,.33.72,10.21,10.21,0,0,0,.59.94c.2.29.54.7.92,1.14.75.87,1.71,1.9,2.68,3.09a19.26,19.26,0,0,1,2.62,4.13,11.28,11.28,0,0,1,1.07,5c0,3.05-1.55,5.56-3.15,6.51s-2.8.48-3.19-.22a19.57,19.57,0,0,1-.74-2.53,9.66,9.66,0,0,0-1.52-2.38,4.58,4.58,0,0,0-1.16-1c-.51-.42-1.15-.9-2-1.54s-1.92-1.43-3.16-2.55a20.41,20.41,0,0,1-2-2,16.92,16.92,0,0,1-1.84-2.73A13.46,13.46,0,0,1,579.91,297.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.91,297.34a11.12,11.12,0,0,1,1.21-4.19,11.41,11.41,0,0,1,2.2-2.87,14.8,14.8,0,0,1,2.92-2.17,2.1,2.1,0,0,1,.6-.24,1.92,1.92,0,0,0,.54-.32,6.63,6.63,0,0,0,1.69-2.54,6.1,6.1,0,0,1,1.37-2.38c.64-.52,1.78-.54,3.06.55a7.84,7.84,0,0,1,2.31,6.53,9.49,9.49,0,0,1-.54,2.54,12.23,12.23,0,0,1-1.28,2.5c-1,1.44-1.89,2.46-2.2,3.07l-.08.17H592l0,0a.93.93,0,0,1,.08.17,6.26,6.26,0,0,0,.33.72,10.21,10.21,0,0,0,.59.94c.2.29.54.7.92,1.14.75.87,1.71,1.9,2.68,3.09a19.26,19.26,0,0,1,2.62,4.13,11.28,11.28,0,0,1,1.07,5c0,3.05-1.55,5.56-3.15,6.51s-2.8.48-3.19-.22a19.57,19.57,0,0,1-.74-2.53,9.66,9.66,0,0,0-1.52-2.38,4.58,4.58,0,0,0-1.16-1c-.51-.42-1.15-.9-2-1.54s-1.92-1.43-3.16-2.55a20.41,20.41,0,0,1-2-2,16.92,16.92,0,0,1-1.84-2.73A13.46,13.46,0,0,1,579.91,297.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M594.71,339.09a5.66,5.66,0,0,1,.93-3.06c.5-.77,1.1-1.44,1.59-2.11a6.49,6.49,0,0,0,1-1.95,3.69,3.69,0,0,0,.16-.85l.13.07a3.12,3.12,0,0,1,1.31,2,6.06,6.06,0,0,1-.11,2.47,5.41,5.41,0,0,1-1.3,2.62,3.57,3.57,0,0,1-3.12,1A3.41,3.41,0,0,1,594.71,339.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M593.51,336.37a10.77,10.77,0,0,1,.63-3.24,3.59,3.59,0,0,1,2.37-2.19,2.84,2.84,0,0,1,1.71.08,4.11,4.11,0,0,1-.2.87,6.76,6.76,0,0,1-1.06,1.83c-.49.64-1.1,1.31-1.63,2.12a5.73,5.73,0,0,0-.9,2.55,5.21,5.21,0,0,0,0,.55,1.88,1.88,0,0,1-.68-.69A3.32,3.32,0,0,1,593.51,336.37Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Briefcase--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.81,411.38h69.13a6.42,6.42,0,0,1,6.42,6.42V460a6.43,6.43,0,0,1-6.43,6.43H81.81a6.19,6.19,0,0,1-6.19-6.19v-42.7A6.19,6.19,0,0,1,81.81,411.38Z",
    transform: "translate(232.99 877.84) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.81,411.38h69.13a6.42,6.42,0,0,1,6.42,6.42V460a6.43,6.43,0,0,1-6.43,6.43H81.81a6.19,6.19,0,0,1-6.19-6.19v-42.7A6.19,6.19,0,0,1,81.81,411.38Z",
    transform: "translate(232.99 877.84) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94,411.38h75.55a0,0,0,0,1,0,0v55.08a0,0,0,0,1,0,0H94a6.19,6.19,0,0,1-6.19-6.19v-42.7A6.19,6.19,0,0,1,94,411.38Z",
    transform: "translate(257.29 877.84) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73,466.73c-.14,0-.26-12.21-.26-27.28s.12-27.3.26-27.3.27,12.22.27,27.3S87.88,466.73,87.73,466.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48,410.7a1.47,1.47,0,0,1,.23-.32,10.76,10.76,0,0,1,.73-.84,20,20,0,0,1,3.13-2.64,21.41,21.41,0,0,1,25.41.72,19.36,19.36,0,0,1,3,2.81c.33.36.53.68.69.88a1.42,1.42,0,0,1,.21.33,34.61,34.61,0,0,0-4.09-3.73,21.71,21.71,0,0,0-25-.71A33.57,33.57,0,0,0,107.48,410.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.24,419.26a2.45,2.45,0,0,1,.06.29c0,.23.09.51.15.87s.13.86.24,1.41.27,1.19.43,1.9A38.79,38.79,0,0,0,93,435.06a39.29,39.29,0,0,0,34.53,18.21,42.92,42.92,0,0,0,21.36-6.15,46.71,46.71,0,0,0,13.4-12.4,49.93,49.93,0,0,0,5.94-10.86c.52-1.37.9-2.45,1.12-3.19.12-.34.21-.62.28-.83s.11-.29.12-.28,0,.1-.07.29-.13.5-.22.85c-.19.76-.55,1.84-1,3.23a47.85,47.85,0,0,1-5.83,11,46.47,46.47,0,0,1-13.45,12.6,43.19,43.19,0,0,1-21.6,6.26,40.66,40.66,0,0,1-21.73-5.63,40.15,40.15,0,0,1-13.12-12.9,37.89,37.89,0,0,1-4.79-11.48c-.14-.72-.27-1.36-.38-1.92s-.14-1-.19-1.43l-.1-.87A1,1,0,0,1,87.24,419.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.23,353.31l-1.55-79.39a36.53,36.53,0,0,1,36.48-37.25h0A36.53,36.53,0,0,1,174.74,273l.42,80.3-71.93,3.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,366.85H215.12c0-7.48-5.05-13.11-12.53-13.11l-99.36-.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.78,
    y: 366.85,
    width: 7.86,
    height: 99.61,
    transform: "translate(399.41 833.32) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.1,
    y: 366.85,
    width: 7.86,
    height: 99.61,
    transform: "translate(232.06 833.32) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,353.74c0-.15,20.82-.26,46.48-.26s46.49.11,46.49.26-20.81.26-46.49.26S112.36,353.88,112.36,353.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,366.9c0-.14,24.46-.26,54.63-.26s54.63.12,54.63.26-24.45.26-54.63.26S105.12,367.05,105.12,366.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,250.81c.14,0,.26,22.66.26,50.61S111.24,352,111.1,352s-.26-22.66-.26-50.61S111,250.81,111.1,250.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,308.75s63-.26,68,0c8.87.48,14.83,10.39,16,15.52s28.7,84.26,28.7,84.26l-21.38,13.83-28.68-64.71-14.43-25.11L147.8,346.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73,330.22s11.62,0,17.9,9.3c3.69,5.46,2.39,15.23,2.47,22.6.1,10-2.51,87.9-2.51,87.9-7.41,5.27-15.69,5.88-24.73,2.34l-6.39-86.19,1.65-12.86-43,.95s-7.64-14.31,3-25.67C176.53,327.13,226.73,330.22,226.73,330.22Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,330.64l.33,0,.94.15a14.51,14.51,0,0,1,3.47,1.23,18,18,0,0,1,4.67,3.48,22.86,22.86,0,0,1,4.27,6.42,26.55,26.55,0,0,1,2.14,9.1,72.51,72.51,0,0,1-.29,10.72c-.34,3.75-.53,7.69-.67,11.79s-.28,8.34-.42,12.69c-.53,17.37-1,33.1-1.35,44.52-.18,5.68-.33,10.28-.43,13.5-.07,1.56-.11,2.79-.15,3.67l0,.95a1.34,1.34,0,0,1,0,.32,1.14,1.14,0,0,1,0-.32v-1c0-.87,0-2.1,0-3.67.07-3.22.16-7.82.28-13.5.25-11.39.64-27.14,1.19-44.53.14-4.35.29-8.59.43-12.69s.34-8.06.7-11.81a72,72,0,0,0,.34-10.65,26.32,26.32,0,0,0-2-9,22.64,22.64,0,0,0-4.14-6.37,18,18,0,0,0-4.55-3.5A16.8,16.8,0,0,0,232.15,330.64Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58,449.21l0,1.59s27,10.51,27.28,15.6l-53.3.26.64-17.74C227.17,452.55,235.46,452.92,244.58,449.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.58,466.66l.16-4.27,51,1.32s2.37,1,2.11,2.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.78,405.24l.61,1.46s28.92-.16,31.11,4.45L272.05,431l-5.94-16.72C274.83,414.76,282.68,412.05,289.78,405.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.05,431l-1.43-4,47.92-17.59s2.59.08,3,1.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62,406.77c.08.24-1.08.84-1.95,2.09s-1.11,2.53-1.37,2.52-.46-1.54.63-3S290.58,406.53,290.62,406.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.52,271.36l9.62,1.55,6.24,8.66-1.81,6.59-1.15.37.23,2.47a2.72,2.72,0,0,1-1.43,2.67h0l-5-8.63,2.06,8.75s-1.24.5-3.36-.57-4.37-10.83-4.37-10.83l-3.32-2.07,3.26,10.84a3.64,3.64,0,0,1-2.83,1c-1.84-.1-5.58-9.94-5.58-9.94l-50.07,7-.1-6.47,12.14-20.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,170.28a9.14,9.14,0,0,0-13.47,7.81c-.12,4.33,2.78,8.76,1.09,12.74-1.11,2.59-3.84,4.06-5.58,6.27s-1.76,6.4,1,7c-3.8-.13-7.28,2.95-8.16,6.66a11.65,11.65,0,0,0,3.23,10.45,18.27,18.27,0,0,0,10.06,5c5.33.95,11.25,0,15.26-3.61s5.38-10.31,2.12-14.63a5.65,5.65,0,0,0,7.53-8.42c-1.51-1.43-3.69-1.93-5.33-3.21-2.27-1.76-3.21-4.81-3.11-7.67a27.1,27.1,0,0,1,2.06-8.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,222.63a6.56,6.56,0,0,1-1.81-1.54,10.68,10.68,0,0,1-2.52-5.91,12.21,12.21,0,0,1,2.9-9,14.94,14.94,0,0,1,4.39-3.63,37,37,0,0,0,5.19-3,6.37,6.37,0,0,0,1.84-2.27,6,6,0,0,0,.49-2.79,19,19,0,0,0-1.44-5.35,21.2,21.2,0,0,1-1.41-4.94,11.05,11.05,0,0,1,.27-4.49,9.31,9.31,0,0,1,3.7-5.24,4.25,4.25,0,0,1,1.66-.61,2.66,2.66,0,0,1,.46,0c.1,0,.15,0,.15,0a5.49,5.49,0,0,0-2.17.79,9.38,9.38,0,0,0-3.45,5.17,10.85,10.85,0,0,0-.19,4.33,21.13,21.13,0,0,0,1.42,4.83,19,19,0,0,1,1.51,5.49,6.51,6.51,0,0,1-.53,3,6.88,6.88,0,0,1-2,2.47,37.52,37.52,0,0,1-5.27,3,14.61,14.61,0,0,0-4.27,3.5,11.91,11.91,0,0,0-2.9,8.66,10.75,10.75,0,0,0,2.31,5.82A17.14,17.14,0,0,0,110,222.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85,308.5q-30.51-.74-58.86.14l.2-.13,6.56-61.75-25.42-42.92-19.48-3.06h-6.52l-5.21,2.9c-6.54,5.74-18.58,18-18.58,18.45s16.1,78.74,16.1,78.74l9.59,9.41-27.12,19.07s.55,18.82,13.28,24,69.29,1.25,75.89.43c0,0,24.72-9.61,28.14-12.55S248.83,314.91,247.85,308.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.13,317.21a4.09,4.09,0,0,1,.59.06l1.67.26c1.44.24,3.53.62,6.1,1.15,5.13,1,12.19,2.67,19.93,4.63l19.82,5.13,6,1.57,1.63.44a2.4,2.4,0,0,1,.56.19,2.14,2.14,0,0,1-.58-.09l-1.65-.34c-1.43-.32-3.5-.8-6-1.41-5.1-1.23-12.11-3-19.85-5s-14.78-3.65-19.89-4.77c-2.55-.57-4.63-1-6.06-1.31l-1.65-.36A2.16,2.16,0,0,1,180.13,317.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65,308.17a21.51,21.51,0,0,1,4.75.07,22.28,22.28,0,0,1,4.72.6,22,22,0,0,1-4.76-.08A21.89,21.89,0,0,1,174.65,308.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,296.91c.13-.09,1.71,2,4.06,4.18s4.55,3.6,4.47,3.74a21.13,21.13,0,0,1-8.53-7.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,264.5c-.06-.07.81-.87,2-2.34a23.32,23.32,0,0,0,3.55-6.38,23.65,23.65,0,0,0,1.39-7.17c.06-1.88-.1-3,0-3.05s.11.28.19.81a14.28,14.28,0,0,1,.19,2.25,21,21,0,0,1-5,13.77,15.16,15.16,0,0,1-1.59,1.61A3,3,0,0,1,173,264.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,207.77h0c7.06,4.37,13.66,14,15.41,26l3.91,18.5s3-1.58,4.78.66a7.26,7.26,0,0,1,1.56,5.59l8.12,5.67-13,9.44-8.87,10.92s7.61,22.37,8.87,24.57,3.77,6,3.77,6l-11.62-2.23s-7.85-5.65-7.54-15.08,1.24-45.54,0-50.25-15.86-43.84-15.86-43.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.65,284.32a2.29,2.29,0,0,1-.08-.54c0-.42-.07-.94-.13-1.57-.06-1.37-.09-3.36,0-5.8.13-4.9.67-11.63,1-19.07a175.66,175.66,0,0,0-.1-19.07c-.19-2.43-.35-4.4-.52-5.76l-.15-1.56a2.08,2.08,0,0,1,0-.55,1.84,1.84,0,0,1,.12.53c.07.42.15.93.25,1.56.24,1.35.45,3.32.69,5.75a150.27,150.27,0,0,1,.25,19.12c-.35,7.46-.94,14.19-1.17,19.06-.12,2.44-.15,4.42-.14,5.78,0,.63,0,1.15,0,1.57A2,2,0,0,1,193.65,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,209.11a3.41,3.41,0,0,1,.35.49c.21.33.52.82.9,1.46.77,1.28,1.86,3.15,3.11,5.51a86,86,0,0,1,4,8.5,28.35,28.35,0,0,1,1.62,5.33,7.29,7.29,0,0,1,.16,1.48v.76l-.07.74c-.11,1-.22,2-.34,3a16.34,16.34,0,0,0-.07,3,11.48,11.48,0,0,0,.65,2.78l1,2.64a10.67,10.67,0,0,1,.4,1.33,10.5,10.5,0,0,1,.28,1.33,21.67,21.67,0,0,1-.85,9.35,48.43,48.43,0,0,1-2.22,5.93c-.31.68-.55,1.21-.72,1.56a2.61,2.61,0,0,1-.29.53,2.27,2.27,0,0,1,.19-.57c.17-.42.37-1,.63-1.6a58.8,58.8,0,0,0,2.05-5.95,21.43,21.43,0,0,0,.73-9.17,9.92,9.92,0,0,0-.28-1.29,9,9,0,0,0-.39-1.29l-1-2.63a11.55,11.55,0,0,1-.68-2.91,16.49,16.49,0,0,1,.06-3.06c.19-2,.65-4,.25-5.83a27.13,27.13,0,0,0-1.56-5.25,92.34,92.34,0,0,0-3.86-8.5c-1.21-2.37-2.24-4.27-2.95-5.58-.34-.61-.61-1.11-.82-1.51A2,2,0,0,1,179.26,209.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.49,274.92,165.62,253l-26.5-49.33-20.35,9.83a10.09,10.09,0,0,0-1.55.75h0a14.76,14.76,0,0,0-4.86,5.21,24.35,24.35,0,0,0-3,16.33l7.84,49.72A130.5,130.5,0,0,0,124.86,302L113,337.78s30.3,15.14,40.09,15.1c8.27,0,15.5-.09,16.87-16.22S168.49,274.92,168.49,274.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,284.32c-.07,0,.3-1,.77-2.6a27.25,27.25,0,0,1,1-2.8,7.56,7.56,0,0,1,2.15-3,6,6,0,0,1,3.48-1.26,6.82,6.82,0,0,1,3,.55,5.51,5.51,0,0,1,1.69,1.11c.34.34.48.56.46.58a10.26,10.26,0,0,0-2.29-1.35,6.87,6.87,0,0,0-2.8-.41,5.69,5.69,0,0,0-3.19,1.19,7.56,7.56,0,0,0-2,2.79c-.46,1-.78,1.93-1.08,2.72A9.64,9.64,0,0,1,143.22,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,264.86a1.94,1.94,0,0,1,.7-.27,7.54,7.54,0,0,1,2.05-.24,8.5,8.5,0,0,1,8.44,9,7.67,7.67,0,0,1-.36,2,1.9,1.9,0,0,1-.32.69,20.14,20.14,0,0,0,.31-2.72,8.49,8.49,0,0,0-8.08-8.61A20.91,20.91,0,0,0,136.65,264.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,225.28a8.68,8.68,0,0,1,.48,1.5c.27,1,.63,2.39,1,4.15.81,3.53,1.76,8.44,2.45,13.92s1,10.47,1.06,14.08c.05,1.81.05,3.28,0,4.29a10.33,10.33,0,0,1-.08,1.57,8.29,8.29,0,0,1-.12-1.57c0-1.1-.11-2.54-.19-4.27-.17-3.6-.53-8.58-1.21-14s-1.57-10.36-2.29-13.9c-.35-1.7-.65-3.11-.87-4.18A10.3,10.3,0,0,1,136.64,225.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,215.26a6.53,6.53,0,0,1,2.3-.25,16.19,16.19,0,0,1,5.5,1,16.42,16.42,0,0,1,4.84,2.79,7,7,0,0,1,1.59,1.68c-.11.15-2.55-2.52-6.61-4A24.79,24.79,0,0,0,118.9,215.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.77,303.53a2.54,2.54,0,0,1,.4.51l1.07,1.5a17.07,17.07,0,0,0,5.17,4.28,17.85,17.85,0,0,0,9.69,1.78,23.91,23.91,0,0,0,11.33-4.27,26.93,26.93,0,0,0,2.38-1.87l-.09.2c0-8.05-.06-15.21-.08-20.44,0-2.54,0-4.6,0-6.1,0-.67,0-1.22,0-1.64a3.29,3.29,0,0,1,0-.58,2.18,2.18,0,0,1,.06.57q0,.64.06,1.65c0,1.5.07,3.56.13,6.1.06,5.22.15,12.38.25,20.43v.13l-.08.06a28.15,28.15,0,0,1-2.43,1.92,24.09,24.09,0,0,1-11.59,4.32,18.11,18.11,0,0,1-9.91-1.93,16.77,16.77,0,0,1-5.15-4.48c-.45-.67-.77-1.21-1-1.58A3.28,3.28,0,0,1,125.77,303.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,205.29a3.9,3.9,0,0,1,.1.73c0,.54.12,1.23.2,2.11.17,1.82.38,4.47.88,7.7a42.68,42.68,0,0,0,3.1,11,27.65,27.65,0,0,0,3.48,5.75,24.71,24.71,0,0,0,2.43,2.6,9.25,9.25,0,0,1,2.44,2.9,5.4,5.4,0,0,1-.07,3.8,23.37,23.37,0,0,0-1,3.42,13.17,13.17,0,0,0,.66,6.57,20.58,20.58,0,0,0,6.67,9.06,56.74,56.74,0,0,0,6.36,4.41l1.8,1.11a3.9,3.9,0,0,1,.61.41,3,3,0,0,1-.66-.32l-1.85-1a49.16,49.16,0,0,1-6.49-4.3,20.81,20.81,0,0,1-6.9-9.19,13.63,13.63,0,0,1-.7-6.82,23.06,23.06,0,0,1,1-3.48,4.89,4.89,0,0,0,.09-3.45,8.78,8.78,0,0,0-2.31-2.72,24.64,24.64,0,0,1-2.47-2.66A27.43,27.43,0,0,1,141.8,227a41.83,41.83,0,0,1-3-11.14c-.46-3.26-.61-5.92-.72-7.75,0-.87-.08-1.58-.1-2.11A3.5,3.5,0,0,1,138,205.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.85,302.16c-3.58,1.51-8.11,2.92-8.86,6.74a27.14,27.14,0,0,1-.52,3.83c-1,2.91-4.68,3.74-7.75,4-5.2.48-10.55.69-15.51-.94s-9.48-5.41-10.67-10.49c4.52,2.79,6.64,6,11.87,6.85,2.94.49,8.42-1.42,11.25-2.35s6.32-4.75,6.32-4.75c.25-1,0-4.23-.24-3.25-.07.33,4.8-2.77,7.23-3.69,2.89-1.08,6.88-3,6.88-3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.23,277c-.79,3.53-3,9.08-4.22,12.51a5.45,5.45,0,0,1-.84,1.71,1.89,1.89,0,0,1-1.66.75,1.94,1.94,0,0,1-1.41-2.15,5.59,5.59,0,0,1,1.16-2.55q3.48-5.15,7-10.27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.31,271.63A24.07,24.07,0,0,1,149.52,238c.77,2.31.17,4.81,0,7.23a18.55,18.55,0,0,0,7.6,15.75c2.19,1.56,4.72,2.63,6.84,4.29s3.87,4.2,3.54,6.87"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,320.93a10.17,10.17,0,0,1,.94-1.72c.64-1.08,1.57-2.61,2.7-4.44l.09-.15.17.06c2.31.84,5.1,1.81,8.13,2.74,4.15,1.28,8,2.25,10.72,2.92l3.28.78a5,5,0,0,1,1.2.34,6.54,6.54,0,0,1-1.24-.14c-.78-.13-1.92-.33-3.32-.62-2.79-.58-6.63-1.5-10.79-2.78-3-.94-5.84-1.94-8.13-2.83l.26-.09c-1.18,1.81-2.16,3.31-2.86,4.34A11.51,11.51,0,0,1,127.55,320.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72,330.32a40.06,40.06,0,0,1,1.56-4.15,39.45,39.45,0,0,1,1.54-4.15,19.06,19.06,0,0,1-3.1,8.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,321.64c0-.08,1.31.69,3.44,1.77a58.7,58.7,0,0,0,8.62,3.52,64.36,64.36,0,0,0,9.07,2.14c2.36.37,3.84.51,3.83.59a3.7,3.7,0,0,1-1.05,0c-.67,0-1.64-.1-2.83-.24a50,50,0,0,1-9.17-2,48,48,0,0,1-8.64-3.68c-1.05-.59-1.88-1.09-2.44-1.48A4,4,0,0,1,127.6,321.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.86,329.6a1.34,1.34,0,0,1-.63,1.72,3.7,3.7,0,0,1-2,.32,35.33,35.33,0,0,1-20.28-7.4c-.59-.46-1.2-1.31-.69-1.86s1.18-.15,1.72.16a56.38,56.38,0,0,0,22.51,7.38"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M106.18,199.56a5,5,0,0,0-2.42-1.12,4.82,4.82,0,0,0-3,.53,3.93,3.93,0,0,0-1.39,1.31,4.33,4.33,0,0,0-.62,2.05,4.38,4.38,0,0,0,2.2,4.12,6.26,6.26,0,0,0,5.52-.21,10,10,0,0,0,5.33-11.09,33.33,33.33,0,0,0-2.39-6.54,22.75,22.75,0,0,1-2-6.31,8.83,8.83,0,0,1,1.17-5.85,9.6,9.6,0,0,1,3.92-3.44,11.81,11.81,0,0,1,7.4-.77,12.42,12.42,0,0,1,2,.54,3.89,3.89,0,0,1,.66.28c0,.06-.93-.33-2.66-.62a12,12,0,0,0-7.21.9,9.13,9.13,0,0,0-3.71,3.34,8.38,8.38,0,0,0-1.06,5.56,22.07,22.07,0,0,0,1.94,6.16,33.61,33.61,0,0,1,2.43,6.65,10.48,10.48,0,0,1-5.63,11.63,6.73,6.73,0,0,1-5.93.15,4.34,4.34,0,0,1-1.89-2,5.19,5.19,0,0,1-.48-2.5,4.74,4.74,0,0,1,.71-2.21,4.12,4.12,0,0,1,1.53-1.39,5,5,0,0,1,3.21-.47,4.37,4.37,0,0,1,1.88.82A2.5,2.5,0,0,1,106.18,199.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,172.85a4.84,4.84,0,0,1,2.35-5.22c1.85-.87,4.5.37,4.62,2.42l3.43.21q3.52,9.38,6.2,19a16.4,16.4,0,0,1,.82,5,5.81,5.81,0,0,1-2.05,4.47,5.26,5.26,0,0,1-5.23.45,8.27,8.27,0,0,1-3.84-3.8,11.85,11.85,0,0,1-1.09-8.22,4.79,4.79,0,0,1-2-9.23A9.41,9.41,0,0,1,121.1,172.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,200.88a16.69,16.69,0,0,1-13.21-7.45,18,18,0,0,1-2-15.44c-4.45-5.54-4-14.58.9-19.44a15.5,15.5,0,0,0,2.58-2.73c1.24-2,.95-4.68,1.29-7.08a12.29,12.29,0,0,1,6.4-9.12,11.68,11.68,0,0,1,10.94.33c2.93-2.48,6-5,9.6-6.12s8-.6,10.66,2.32c1.45,1.61,2.33,3.86,4.17,4.93s4.16.67,6.21,1.27c3.9,1.15,6,5.64,6.9,9.76s-1.8,9.13.76,12.44c1.34,1.72,3.18,3,4.27,4.92a7.5,7.5,0,0,1,.15,7A6.68,6.68,0,0,1,189.9,180c2.32,3.26-4.22,14-13.39,14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.33,210.53l-3-56.36h0a4.4,4.4,0,0,1,3.88-4.51l23.29-6.18c7.47-.87,12.55,8.28,13.11,15.78.62,8.33,1.06,18.53.14,24.76-1.84,12.54-11.41,14.25-11.41,14.25s0,6,0,13.41a8.81,8.81,0,0,1-11.43,8.43A29.94,29.94,0,0,1,144.33,210.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,168.75a1.61,1.61,0,0,1-1.53,1.64,1.53,1.53,0,0,1-1.67-1.43,1.6,1.6,0,0,1,1.53-1.64A1.54,1.54,0,0,1,178.82,168.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.67,165.6c-.2.21-1.43-.68-3.15-.65s-3,.9-3.17.69.1-.47.65-.88a4.39,4.39,0,0,1,2.53-.82,4.25,4.25,0,0,1,2.51.78C179.58,165.12,179.76,165.5,179.67,165.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34,168.41a1.6,1.6,0,0,1-1.53,1.64,1.53,1.53,0,0,1-1.67-1.43,1.62,1.62,0,0,1,1.53-1.64A1.55,1.55,0,0,1,162.34,168.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58,165.58c-.2.21-1.43-.68-3.15-.65s-3,.9-3.18.69.11-.47.66-.88a4.44,4.44,0,0,1,2.53-.81,4.18,4.18,0,0,1,2.51.78C162.49,165.11,162.67,165.48,162.58,165.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,177.85a11.09,11.09,0,0,1,2.8-.54c.44-.05.85-.15.92-.45a2.23,2.23,0,0,0-.31-1.3c-.42-1.06-.87-2.18-1.34-3.34-1.87-4.76-3.22-8.68-3-8.75s1.86,3.72,3.73,8.48l1.29,3.36a2.62,2.62,0,0,1,.25,1.73,1.14,1.14,0,0,1-.72.66,3.77,3.77,0,0,1-.75.11A12.1,12.1,0,0,1,168.89,177.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.32,198.27A31.82,31.82,0,0,1,153.51,194s4.33,8.78,16.84,7.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,182a3.11,3.11,0,0,0-2.81-1.13,2.83,2.83,0,0,0-2,1.08,1.81,1.81,0,0,0-.11,2.06,2.07,2.07,0,0,0,2.27.54,6.38,6.38,0,0,0,2.19-1.34,1.73,1.73,0,0,0,.49-.52.57.57,0,0,0,0-.64",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.82,179.1c.28,0,.31,1.85,1.93,3.17s3.61,1.08,3.63,1.34-.44.37-1.29.4a4.67,4.67,0,0,1-3-1,4.05,4.05,0,0,1-1.49-2.66C163.49,179.56,163.69,179.09,163.82,179.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,161c-.16.47-1.89.27-3.91.53s-3.66.84-3.93.43c-.12-.2.16-.65.81-1.11a6.6,6.6,0,0,1,2.91-1.06,6.67,6.67,0,0,1,3.07.33C162.62,160.36,163,160.72,162.93,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,161.53c-.3.4-1.49,0-2.92,0s-2.64.3-2.92-.11c-.13-.2.06-.59.58-1a4.24,4.24,0,0,1,4.71.09C180,160.94,180.13,161.34,180,161.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,142.71a8.57,8.57,0,0,0,10.19,8.35c1.9-.37,4-1.35,5.65-.35s1.85,3.68,3.41,5c2.22,1.9,5.71.07,8.52.87,2.17.62,3.54,2.68,5,4.4s3.62,3.36,5.78,2.7a25.92,25.92,0,0,0-.91-5.76,8.52,8.52,0,0,0-3.32-4.67,30.31,30.31,0,0,1-2.78-1.59c-1.81-1.43-2.25-3.95-3.38-6A9.37,9.37,0,0,0,173,141c-2.47-.23-5,.53-7.4-.05-1.78-.43-3.34-1.57-5.14-1.89-3.51-.63-6.74,1.91-9.25,4.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,145.35c1.35,2.52,2,9,1,11.67a10,10,0,0,1-6,5.74,10.72,10.72,0,0,1-.39,14.42c-1.57,1.53-3.73,2.71-4.32,4.81s.55,4.08,1.08,6.11a11.45,11.45,0,0,1-1.28,8.76c-.91,1.49-2.38,2.85-4.13,2.84s-3-1.17-4-2.39a20.27,20.27,0,0,1-4.37-17.19l4.42-21.23,5.76-12.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,178.77a1.67,1.67,0,0,1-.11-.43c-.06-.29-.13-.71-.21-1.25a33,33,0,0,1-.35-4.66,20.2,20.2,0,0,1,1.1-6.85,13.57,13.57,0,0,1,5.08-6.77c2.6-1.73,5.6-2,8.12-2.48a24.23,24.23,0,0,0,3.54-.83,11,11,0,0,0,2.79-1.46,6.74,6.74,0,0,0,2.7-3.56,11.81,11.81,0,0,0,.22-1.67,3.64,3.64,0,0,1,0,1.72,6.68,6.68,0,0,1-2.67,3.81,11.78,11.78,0,0,1-2.86,1.57,24.74,24.74,0,0,1-3.61.9c-2.53.48-5.45.79-7.91,2.43a13.33,13.33,0,0,0-4.92,6.51,20.64,20.64,0,0,0-1.18,6.69,40.65,40.65,0,0,0,.18,4.63A11.76,11.76,0,0,1,131.57,178.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,149.58a1.46,1.46,0,0,1,.76-.38,4.5,4.5,0,0,1,2.31,0c2,.42,4,2.42,6.92,2.57a10.26,10.26,0,0,0,6.87-2,15.44,15.44,0,0,0,2.2-2.13,2.53,2.53,0,0,1-.4.74,8.43,8.43,0,0,1-1.57,1.68,10.13,10.13,0,0,1-7.15,2.2,9.58,9.58,0,0,1-4-1.28,15.74,15.74,0,0,0-3-1.45A4.94,4.94,0,0,0,136.06,149.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,174.41a5.68,5.68,0,0,0,.16-2.2,9,9,0,0,0-3.07-5.08c-.92-.91-2-1.83-3-3a10.91,10.91,0,0,1-2.2-4.41c-.45-1.68-.66-3.48-1-5.29a12.43,12.43,0,0,0-2.13-5.18,6,6,0,0,0-2.14-1.79,5.47,5.47,0,0,0-2.64-.51,36.73,36.73,0,0,0-5.21,1.09,9.63,9.63,0,0,1-2.55.24,7,7,0,0,1-2.36-.57,28,28,0,0,1-3.67-2.17,7.25,7.25,0,0,0-5.68-1.43,3.25,3.25,0,0,0-1.44.73c-.28.25-.4.41-.42.39s0,0,.07-.13a2,2,0,0,1,.28-.34,3.23,3.23,0,0,1,1.46-.85,7.4,7.4,0,0,1,5.92,1.31,28,28,0,0,0,3.65,2.09,6.55,6.55,0,0,0,2.22.51,9.27,9.27,0,0,0,2.42-.25,34.43,34.43,0,0,1,5.29-1.13A6,6,0,0,1,182,147a6.45,6.45,0,0,1,2.32,1.93,13,13,0,0,1,2.23,5.4c.35,1.85.55,3.63,1,5.27a10.49,10.49,0,0,0,2.06,4.25c1,1.16,2,2.1,2.94,3a9,9,0,0,1,3,5.32,4.3,4.3,0,0,1-.13,1.68,2.33,2.33,0,0,1-.16.41C195.23,174.37,195.21,174.41,195.2,174.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,137.56a1.79,1.79,0,0,1-.25.84,4.41,4.41,0,0,1-1.67,1.75,6.56,6.56,0,0,1-3.47.91,21.74,21.74,0,0,1-4.31-.57,14.45,14.45,0,0,0-4.2-.35,5.4,5.4,0,0,0-3.08,1.27,4.16,4.16,0,0,0-1.25,1.88c-.15.52-.14.84-.19.84a1.53,1.53,0,0,1,0-.89,3.93,3.93,0,0,1,1.2-2.1,5.6,5.6,0,0,1,3.27-1.48A14.28,14.28,0,0,1,164,140a24.22,24.22,0,0,0,4.21.6,6.42,6.42,0,0,0,3.28-.75,4.47,4.47,0,0,0,1.68-1.53C173.5,137.84,173.59,137.54,173.64,137.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,155.8a6.69,6.69,0,0,1-.49-1.23,24.89,24.89,0,0,1-1-3.46,11.38,11.38,0,0,1,.11-5.36,8.31,8.31,0,0,1,1.49-2.85,5.93,5.93,0,0,1,2.86-2,7.94,7.94,0,0,1,3.45-.15,29.12,29.12,0,0,1,3.08.69l5.13,1.38,3.44,1a7.2,7.2,0,0,1,1.25.42,6.08,6.08,0,0,1-1.3-.23l-3.49-.81L144,142a27.63,27.63,0,0,0-3-.66,7.47,7.47,0,0,0-3.22.15,6.46,6.46,0,0,0-4,4.44,11.46,11.46,0,0,0-.21,5.16c.25,1.47.59,2.65.8,3.46A6.31,6.31,0,0,1,134.54,155.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,198.44c0-.15,1.08-.47,2.18-1.33s1.69-1.86,1.82-1.79a4.37,4.37,0,0,1-4,3.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.48,193.63c0-.14.82-.53,1.77-1.19s1.63-1.33,1.74-1.23-.42.95-1.45,1.66A3.1,3.1,0,0,1,127.48,193.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54,187.8c-.1-.1.56-.86,1.67-1.37s2.11-.54,2.12-.4-.88.38-1.9.87S126.63,187.91,126.54,187.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.26,182.15a15.09,15.09,0,0,1,9-.5c0,.15-2-.06-4.49.09S121.29,182.3,121.26,182.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05,177.7a6,6,0,0,1,2.89-.83,6.15,6.15,0,0,1,3,.17,16.1,16.1,0,0,1-2.95.34A16.55,16.55,0,0,1,124.05,177.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,174a4.68,4.68,0,0,1,5.66-1.46,17.22,17.22,0,0,0-3,.24A16.6,16.6,0,0,0,122.33,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,277.73,201.21,268l9.46-2.35,7.46,4.51a4.09,4.09,0,0,1,1.94,2.95l.65,4.84-.91.78,1.18,2.18a2.75,2.75,0,0,1-.27,3h0l-7.62-5.73,5,7s-.94.95-3.3.79-8.27-8.25-8.27-8.25l-3.87-.61,8.14,8.76s.37.73-1.36,1.36-10.77-6.33-10.77-6.33l-42.46,20.75",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,301.61l.19-.11.58-.3,2.25-1.14,8.59-4.27,30.75-15.13a.23.23,0,0,1,.24,0c1.83,1.39,3.78,2.79,5.84,4.12a25.46,25.46,0,0,0,3.23,1.81c.55.22,1.18.52,1.64.29a2.74,2.74,0,0,0,.77-.43c.23-.16.34-.43.29-.53l0,.05-8.14-8.75a.24.24,0,0,1,0-.35.25.25,0,0,1,.21-.07l3.87.6a.23.23,0,0,1,.16.11,62.49,62.49,0,0,0,4.8,5.75,10.45,10.45,0,0,0,2.93,2.3,4.47,4.47,0,0,0,3.46-.62l0,.33-1.47-2.06q-1.77-2.49-3.5-4.93a.25.25,0,0,1,.06-.36.24.24,0,0,1,.3,0l6.17,4.64.76.57.38.28.19.15.09.07h0l-.35,0h0v0l0,0a2.48,2.48,0,0,0,.5-1.6,3.48,3.48,0,0,0-.59-1.62l-.89-1.64a.26.26,0,0,1,.06-.31l.91-.79-.08.23c-.2-1.49-.4-3-.59-4.43a4,4,0,0,0-2.13-3.34l-7.2-4.35.17,0-5.91,1.46c-1.93.47-3.81.95-5.67,1.33l-10.57,2.26-17.32,3.69L160,276.94l-3,.61-.77.14a.74.74,0,0,1-.26,0l.26-.07.76-.19,3-.68,11.22-2.5,17.29-3.79L199,268.19c1.86-.38,3.74-.86,5.67-1.35l5.9-1.47a.28.28,0,0,1,.18,0l7.21,4.34a4.61,4.61,0,0,1,1.67,1.53,4.71,4.71,0,0,1,.7,2.17c.2,1.46.4,2.93.6,4.42a.28.28,0,0,1-.09.23l-.91.78.06-.31.89,1.63a3.94,3.94,0,0,1,.65,1.85A3,3,0,0,1,221,284l0,0v0h0l-.36,0h0l-.09-.07-.19-.15-.38-.28-.76-.57-6.17-4.64.37-.36q1.74,2.44,3.5,4.93l1.48,2.06v0a.25.25,0,0,1,0,.32,4,4,0,0,1-1.94.8,7,7,0,0,1-1,.08l-.5,0c-.17,0-.37-.08-.55-.12a10.65,10.65,0,0,1-3.12-2.43,60.56,60.56,0,0,1-4.84-5.81l.17.1-3.87-.61.23-.42c2.81,3,5.54,6,8.13,8.76v0l0,0a1,1,0,0,1-.42,1.13,3.48,3.48,0,0,1-.9.5,1.36,1.36,0,0,1-.56.12,2.1,2.1,0,0,1-.52-.08,5.39,5.39,0,0,1-.93-.34,25,25,0,0,1-3.29-1.86c-2.08-1.34-4-2.75-5.86-4.15l.23,0-30.83,15-8.65,4.15L157,301.26l-.59.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.07,285.14a16.86,16.86,0,0,1-1.83-2.3c-1.08-1.46-2.54-3.5-4.13-5.77a5,5,0,0,0-2.73-2.39c-1.11-.32-2.2-.5-3.07-.72a16.41,16.41,0,0,1-2.84-.75,16.13,16.13,0,0,1,2.91.39c.9.18,1.94.31,3.15.62a5.36,5.36,0,0,1,3,2.58c1.58,2.26,3,4.33,4,5.84A16.85,16.85,0,0,1,218.07,285.14Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.59,278.81a23.72,23.72,0,0,1-1.75-2,56.11,56.11,0,0,0-4.39-4.58L212.11,271l-.65-.58-.31-.28s-.12-.11-.14-.11h-.09c-1-.12-2-.1-2.83-.13a14.82,14.82,0,0,1-2.64-.12,12,12,0,0,1,2.64-.25,23.82,23.82,0,0,1,2.91,0l.11,0a.67.67,0,0,1,.18.07,1,1,0,0,1,.18.15l.32.27.66.57,1.35,1.22a37.89,37.89,0,0,1,4.32,4.73A9.36,9.36,0,0,1,219.59,278.81Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee-1--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.95 265.85 327.1 295.13 311.99 295.13 309.01 265.85 329.95 265.85",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.23,
    y: 263.71,
    width: 24.99,
    height: 2.14,
    transform: "translate(639.44 529.57) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.46 260.02 329.95 264.19 310.08 264.19 311.04 260.02 327.46 260.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.99 275.71 327.98 286.15 311.08 286.15 310.01 275.71 328.99 275.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,283.87a4.78,4.78,0,0,1,.79-2.58c.42-.66.93-1.22,1.34-1.79a5.29,5.29,0,0,0,.87-1.65,3.77,3.77,0,0,0,.14-.72l.11.06a2.68,2.68,0,0,1,1.11,1.72,5.08,5.08,0,0,1-.1,2.09,4.53,4.53,0,0,1-1.1,2.22,3.06,3.06,0,0,1-2.64.82A3.5,3.5,0,0,1,317.33,283.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.05,281.57a8.78,8.78,0,0,1,.54-2.74,3,3,0,0,1,2-1.85,2.3,2.3,0,0,1,1.45.07,3.36,3.36,0,0,1-.18.73,5.56,5.56,0,0,1-.89,1.55c-.41.55-.93,1.11-1.37,1.79a4.79,4.79,0,0,0-.77,2.16,3.67,3.67,0,0,0,0,.46,1.51,1.51,0,0,1-.57-.58A2.85,2.85,0,0,1,316.05,281.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.37,295.35l17.42-43.75a5.72,5.72,0,0,0-5.29-7.89H247.21a5.73,5.73,0,0,0-5.42,3.88l-15,44.13-17.48.09c-1.43,0-2.65,1.9-2.65,3.32h0l19.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.61,271.91a3.53,3.53,0,1,0,3.53-3.53A3.53,3.53,0,0,0,266.61,271.91Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.37,303.1h147.5a4,4,0,0,0,4-4h0a4,4,0,0,0-4-4H188.37a4,4,0,0,0-4,4h0A4,4,0,0,0,188.37,303.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 301.61,
    width: 12.87,
    height: 164.85,
    transform: "translate(526.86 768.07) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,466.46H219.31c.58,0,37.69-9.84,37.69-9.84h12.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,302.76c0-.14,33.36-.26,74.49-.26s74.5.12,74.5.26-33.35.26-74.5.26S188,302.91,188,302.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.7,466.33c0,.14-147.17.26-328.68.26s-328.72-.12-328.72-.26,147.14-.26,328.72-.26S703.7,466.19,703.7,466.33Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/header-img.2afe052974924a4b5c55e9716ec08bc2.svg";
export { ForwardRef as ReactComponent };